/* eslint-disable */
import React, { useState, useEffect, useReducer, useRef, createContext, useContext } from "react";
import { Button, Collapse, Select, Input, Radio,Space,message, Tooltip, Popover, Typography, Modal, Row, Col, Spin } from "antd"; 
import { FileAddFilled, LoadingOutlined, MoreOutlined,MenuOutlined, CopyOutlined,AppstoreAddOutlined, MinusSquareOutlined, PlusSquareOutlined } from "@ant-design/icons";
import NoteAddIcon from "../../assets/icon_NotePlus_Fill_Black.png"
import { withRouter } from 'react-router';
import { connect } from "react-redux";
import * as createActions from "../../actions/createTrial.js";
import { formatWithCommas, toSentenceCase } from "../../utils/utils";
import SoaDetailsModal from '../SoaDetailsModal'
import {
  MinusCircleOutlined,
  PlusCircleOutlined,
  CloseCircleOutlined,
  DeleteFilled
} from "@ant-design/icons";
import {
  closestCenter,
  DndContext,
  DragOverlay,
  PointerSensor,
  MouseSensor,
  TouchSensor,
  useSensor,
  useSensors,
} from '@dnd-kit/core';
import { restrictToHorizontalAxis } from '@dnd-kit/modifiers';
import {
  arrayMove,
  horizontalListSortingStrategy,
  SortableContext,
  useSortable,
} from '@dnd-kit/sortable';
import {CSS} from '@dnd-kit/utilities';
import "./index.scss";
import ascendIcon from "../../assets/icon_ChevronUp_Outline_Black.png";
import descendIcon from "../../assets/icon_ChevronDown_Outline_Black.png";
const { Panel } = Collapse;
const { TextArea } = Input;
const { Text } = Typography;

const LABS = 'Labs';
const PHYSICAL_EXAMINATION = 'Physical Examination';
const PROCEDURES = 'Procedures';
const QUESTIONNAIRES = 'Questionnaires';
const STUDY_PROCEDURES = 'Study Procedures';

const initialActivity = {
  Categories:'',
  'Standard Activity': '',
  activity_id: '',
  condition: '',
  cost: '',
  historical_event : "", 
  endpoint: [],
  idx: '',
  modality: [],
  selected: false,
  soaWeights: [],
  totalVisit: '', 
  visit_frequency: null, 
  Frequency: null
}

const DragIndexContext = createContext({
  active: -1,
  over: -1,
  direction:'',
});

const colorList =  [
  {
      "visit_type_id": 1,
      "visit_type": "Screening Visits",
      "color": "#FFB600",
  },
  {
    "visit_type_id": 2,
    "visit_type": "Treatment Visits",
    "color": "#EB8C00",
},
  {
      "visit_type_id": 3,
      "visit_type": "Follow-up Visits",
      "color": "#295477",
  },
  {
    "visit_type_id": 4,
    "visit_type": "Fixed Cycle",
    "color": "#EB8C00", 
},
{
    "visit_type_id": 5,
    "visit_type": "Repeating Cycle",
    "color": "#D04A02",
},
]

const NewEventList = (props) => {
  const {
    orgLabs,
    orgExamination,
    orgProcedures,
    orgQuestionnaires,
    orgStudyProcedures,
    soeReadOnly, 
    numbers : { weekNumber },
    periodData,
    soaOncologyFlag,
    currentVisitTypes,
    visitTypeLib,
    openSoaDetailsModal, 
    selection, 
    resetAddInsights, 
    periodDataUpdate }= props;
  
  const trialEndpoints=props.endpoints
  const viewOnly = props.viewOnly ||false;
  const [sort,setSort] = useState("")
  const [dayWeekList, setDayWeekList] = useState([]);
  // Note: 'soaVisits' is the reordered 1:n visit array, while 'visits' is the real visit array which may be different from 'soaVisits' after dragging
  const [visits, setVisits] = useState([])
  const [visitsShowOnly, setVisitsShowOnly] = useState([])
  const [expandKeys, setExpandKeys] = useState([])
  let [labs, setLabs] = useState(props.labs||[]);
  let [examination, setExamination] = useState(props.examination||[])
  let [procedures, setProcedures] = useState(props.procedures||[])
  let [questionnaire, setQuestionnaire] = useState(props.questionnaire||[])
  let [studyProcedures, setStudyProcedures] = useState(props.studyProcedures||[])
  const [showMetrics, setShowMetrics] = useState(false);

  const [rowModality, setRowModality] =  useReducer(
    (state, newState) => ({ ...state, ...newState }),
    {}
  );
  const [columnModality, setColumnModality] =  useReducer(
    (state, newState) => ({ ...state, ...newState }),
    {}
  );

  const [editActivityModal, setEditActivityModal] = useState(false)
  const [selectedEditActivity, setSelectedEditActivity] = useState(initialActivity)
  const [popoverStates, setPopoverStates] = useState([]);  
  const [eventNumbers, setEventNumbers] = useState({evtWeekNumber:0});

  const modalityOptions = props.modalityOptions.length > 0 ? props.modalityOptions: props.location.state.modalityOptions
  let elementM = null;
  const collapsedId= localStorage.getItem('ts_id');

  const [visitTypes, setVisitTypes] = useState([]);
  const [currentVisitIndex, setCurrentVisitIndex] = useState([]);

  const [notesList, setNotesList] = useState([])
  const [editShow, setEditShow] = useState([])

  const [dragIndex, setDragIndex] = useState({
    active: -1,
    over: -1,
    direction:'',
  }); 
  const [dragVisitIndex, setDragVisitIndex] = useState({
    active: -1,
    over: -1,
    direction:'',
  });  
  const [periodType, setPeriodType] = useState([]);
  const [whetherDraggable, setWhetherDraggable] = useState(0);
  const [whetherDraggableVisit, setWhetherDraggableVisit] = useState(0);

  const [filteredActivities, setFilteredActivities] = useState([]);
  const eventListHead = useRef();
  const [ collapseWidth, setCollapseWidth ] = useState(null);

  const getWidth = () => {
    const divElement: HTMLDivElement = eventListHead.current;
    return divElement?.offsetWidth;
  }

  useEffect(() => {
    handleResize();
  }, [eventNumbers, periodData])

  useEffect(() => {
    let visits = visitTypeLib;
    setVisitTypes(visits)
  }, [visitTypeLib])

  useEffect(() => {
    setLabs(props.labs||[])
    setExamination(props.examination||[])
    setProcedures(props.procedures||[])
    setQuestionnaire(props.questionnaire||[])
    setStudyProcedures(props.studyProcedures||[])
  }, [props.labs, props.examination, props.procedures, props.questionnaire, props.studyProcedures ])
    

  useEffect(() => {
    // Get the re-ordered visit array
    let newVisitArray = visitsShowOnly.map((item, index) => {
      return item?.order
    })
    // Update the visits array in each period
    let newPeriodType = JSON.parse(JSON.stringify(periodType))
    let _newVisits = JSON.parse(JSON.stringify(newVisitArray))
    newPeriodType.forEach((period, index) => {
      const visits = _newVisits.splice(0, period.no_of_visits)
      period.visits = visits
    })  
    // Return the current visit array based on the visit type
    let visitArray = []
    if (currentVisitTypes === 'total_trial') {
      newPeriodType.forEach((item, index) => {
        visitArray.push(...item?.visits)
      })
    } else {
      newPeriodType.forEach((item, index) => {
        if (item?.visit_type === currentVisitTypes) {
          visitArray.push(...item?.visits)
        }
      })
    }
    setCurrentVisitIndex(visitArray)    
  }, [currentVisitTypes, periodType])

  useEffect(() => {
      const expandKeysTmp = JSON.parse(sessionStorage.getItem(`expandKeys_${collapsedId}`));
      if(!expandKeysTmp){
      let expandKeysTmp =[]
      if (props.labs) expandKeysTmp.push('1');
      if (props.examination) expandKeysTmp.push('2');
      if (props.procedures) expandKeysTmp.push('3');
      if (props.questionnaire) expandKeysTmp.push('4');
      if (props.studyProcedures) expandKeysTmp.push('5');
      setExpandKeys(Array.from(new Set(expandKeysTmp)));
    } else {
      setExpandKeys(JSON.parse(sessionStorage.getItem(`expandKeys_${collapsedId}`)))
    }
  }, [props.labs, props.examination, props.procedures,props.questionnaire,props.studyProcedures]);
  
  const metricToggle = () => {
    setShowMetrics(val => !val)
  }

  useEffect(() => {
    if(props.viewOnly) setExpandKeys(['1','2','3','4','5'])
  }, [props.viewOnly])

  useEffect(() => { 
    setEventNumbers({
      evtWeekNumber: weekNumber || 0,
    })
  }, [props.numbers])

  useEffect(() => {
    if(!props.visitsList) return;
    let newData = [...props.visitsList]
    let newArr = newData.map(k => ({value: k, edit: false}))
    let tempNotesList = []
    // let notes_list = newData.map(k => tempNotesList[k.visit-1] =  k.visit_notes)
    // setEditShow(newArr)
    setNotesList(tempNotesList)
    setPopoverStates( props?.newSoa?.soaVisitNotesList?.map( item => false))
   
  }, [props.visitsList, props.newSoa?.soaVisitNotesList])

  useEffect(() => {
    const data = props?.periodData?.map((item, index)=>{
      item.period_id = item.period_id === null? index+1:item.period_id
      item.period_order_index =  item.period_order_index === null?index+1:item.period_order_index
      item.period_name = item.period_name === null?item.visit_type : item.period_name    
      return {
        ...item
      }
    }
    )||[]
 
    let arr = [];  
    const prop = soaOncologyFlag ? 'days' : 'weeks';   
    data.forEach(item => {  
      const propData = item[prop];  
      if (propData && propData.length > 0) {  
        propData.forEach(k => {  
          arr.push({  
            ...item,  
            period_name: item.period_name,  
            period_order_index: item.period_order_index,  
            [prop]: k  
          });  
        });  
      }  
    }); 
    
    setDayWeekList(arr)    
    setPeriodType(data) 

    // update visits
    const visitArray = []
    data.forEach((item) => {
      visitArray.push(...item.visits)
    })
    setVisits((prevState)=>{
      return visitArray
    })
   
    setVisitsShowOnly(visitArray.map((item, index) => {
      return {
        "unique_id": item,
        "order": index + 1,
        "value": item,
      }
    }))
    
  }, [props?.periodData])

  useEffect(()=>{
    // updateCondition()
    handleResize()
  },[props.newSoa?.soaWeeks, props.numbers])
  

  useEffect(() => {
    //initial condition 
    if(!props.newSoa?.soaAddedLabs || 
       !props.newSoa?.soaAddedExamination || 
       !props.newSoa?.soaAddedProcedures || 
       !props.newSoa?.soaAddedQuestionnaires || 
       !props.newSoa?.soaAddedStudyProcedures 
       || props.newSoa?.soaPeriod_data?.length == 0
       || (!props.newSoa?.soaVisits || props.newSoa?.soaVisits?.length == 0)
       ) return 
    let tmpLabs = getCondition(props.newSoa?.soaAddedLabs, "Labs")
    let tmpExamination =getCondition(props.newSoa?.soaAddedExamination, "Examination")
    let tmpProcedures = getCondition(props.newSoa?.soaAddedProcedures, "Procedures")
    let tmpQuestionnaire =getCondition(props.newSoa?.soaAddedQuestionnaires, "Questionnaires")
    let tmpStudyProcedures =  getCondition(props.newSoa?.soaAddedStudyProcedures, "StudyProcedures")
    setLabs(tmpLabs);
    setExamination(tmpExamination);
    setProcedures(tmpProcedures);
    setQuestionnaire(tmpQuestionnaire);
    setStudyProcedures(tmpStudyProcedures);
    handleResize();
    props.updateSoaActivities({
      soaAddedLabs : tmpLabs,
      soaAddedExamination: tmpExamination,
      soaAddedProcedures: tmpProcedures,
      soaAddedQuestionnaires: tmpQuestionnaire,
      soaAddedStudyProcedures: tmpStudyProcedures
     }) 
   
  }, [
    props.newSoa?.soaAddedLabs,
    props.newSoa?.soaAddedExamination,
    props.newSoa?.soaAddedProcedures,
    props.newSoa?.soaAddedQuestionnaires,
    props.newSoa?.soaAddedStudyProcedures, 
    props.newSoa?.soaVisits,
    props.newSoa?.soaPeriod_data,
    periodType,
    // weekNumber,
  ]);

  useEffect(() => {
    if(props.submitType != 0){
      onSave()
    }
  }, [props.submitType])

  const handleResize = () => {
    setCollapseWidth(getWidth());
  };

  useEffect(() => {
    if(eventListHead.current) {
      handleResize();
    }

    window.addEventListener("resize", handleResize);  
    window.addEventListener("onclick", handleResize);  
    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);  
      window.removeEventListener("onclick", handleResize);  
    }
  }, [eventListHead])

  useEffect(() => {
    setTimeout(handleResize, 5500);
  }, [])

  useEffect(() =>{ 
    handleResize();
  }, [props.windowResize,props.soeLibrarayPanelStatus, props.numbers])

  useEffect(() => {
    if (props?.newSoa?.soaFilteredLabs?.length > 0 ||    
        props?.newSoa?.soaFilteredExamination.length > 0 ||
        props?.newSoa?.soaFilteredQuestionnaires?.length > 0 ||
        props?.newSoa?.soaFilteredProcedures?.length > 0 ||
        props?.newSoa?.soaFilteredStudyProcedures?.length > 0 )  {
        setFilteredActivities([
          ...props?.newSoa?.soaFilteredLabs,
          ...props?.newSoa?.soaFilteredExamination,
          ...props?.newSoa?.soaFilteredQuestionnaires,
          ...props?.newSoa?.soaFilteredProcedures,
          ...props?.newSoa?.soaFilteredStudyProcedures
        ])
      } else {
        
      }
  }, [props.newSoa])

  useEffect(() => {
    if(!props.newSoa?.isLoaded && elementM && elementM.length == 5 && filteredActivities?.length > 0 && visits?.length > 0) { 

      props.updateSoaActivities({
        isLoaded: true
      })
    }
  }, [filteredActivities, visits, props.newSoa])

  useEffect(() => {
    setEditActivityModal(openSoaDetailsModal)
  }, [openSoaDetailsModal])

  useEffect(() => { 
    setSelectedEditActivity(selection)
  }, [selection])

  const weekDayChangeHandler = (e, idx) => {  
    const regex = /^-?(?!$)(?!.*--)\d+$/;
    const value = e.target.value;
    const val = value === '-' ? '-' : (value !== '' && regex.test(value)) ? parseInt(value) : null;
    if(val != '-' && val > 1000) return;
    
    const daysData = [...dayWeekList]; 
    let selectionIdx = daysData.findIndex((k, i) => idx == i);
    const prop = soaOncologyFlag ? 'days' : 'weeks';  
    daysData[selectionIdx][prop] = val; 
    setDayWeekList(daysData)
    
    const outputArray = [];  
    daysData.forEach((item) => {  
    const existingItem = outputArray.find((outputItem) => outputItem.period_id === item.period_id);   
    if (existingItem) {  
      existingItem[prop].push(item[prop]);  
    } else {  
      outputArray.push({  
        period_name: item.period_name,  
        period_id: item.period_id,  
        period_order_index: item.period_order_index,  
        no_of_visits: item.no_of_visits,  
        visit_type_id: item.visit_type_id,  
        visit_type: item.visit_type,  
        visits: item.visits,  
        visit_notes: item.visit_notes,  
        [prop]: [item[prop]]  
      });  
    }  
    });  
    periodDataUpdate(outputArray)
    setPeriodType(outputArray)
  }

  const mouseSensor = useSensor(MouseSensor);
  const touchSensor = useSensor(TouchSensor);
  const pointerSensor = useSensor(PointerSensor, {
    activationConstraint: {
      distance: 1,
    },
  });

  const sensors = useSensors(
    mouseSensor,
    touchSensor,
    pointerSensor,
  );

  const addVisitNoteList = (id) => {
    if(notesList[id] == undefined) return
    const { visitNoteListHandler, visitsList } = props;    
    let note = notesList[id];
    let list = props?.newSoa?.soaVisitNotesList
    let duplicate_item = list?.find((val, i) => val !== "" && val !== null && val == note.trim())    
    if(duplicate_item) {
      message.error('Duplicate notes cannot be saved')
      return
    };
    const newStates = [...popoverStates];
    newStates[id] = false;
    setPopoverStates(newStates);
    // setNotesList(list)
    list[id] = note;    
    visitNoteListHandler(list);
  }

  const addVisitNotes = (evt, idx) => {
    const note = evt.target.value;
    const notesArr = [...notesList]
    notesArr[idx] = note
    setNotesList(notesArr)  
    // let newData = [...editShow]
    // newData.map(k => ({value: k, edit: false}))
    // setEditShow(newData)
  }

  const getNotesValue = (idx) => {
    if(props?.newSoa?.soaVisitNotesList?.length == 0) return;
    // if(notesList.length == 0) return;
    let list = props?.newSoa?.soaVisitNotesList
    let item = list[idx]
    return item;
  }

  const popOverContent =( idx, viewOnly) => {
    let value = getNotesValue(idx);
    if(viewOnly) {
      return value ?
        <div style={{width: '160px', height: '100px',  padding: '8px', backgroundColor: '#282f34', color: 'white'}}>
          <div style={{height: '80%'}}>
          {value}
          </div>
        </div>
        :
        null
    }
    return (
      <div style={{width: '160px', height: '100px', padding: '8px', backgroundColor: '#282f34', color: 'white'}}>
      <div style={{backgroundColor: 'white', height: '80%'}}>
      <TextArea key={value} rows={2} maxLength={20} defaultValue={value} onChange={(e) => addVisitNotes(e, idx)} showCount={true} />
      </div>
      <a onClick={() => addVisitNoteList(idx)}>Add Note </a>
    </div>
  )}

  const findConditions = (type, conditons) => {
    let activities =[]
    switch(type) {
      case 'Labs':
        activities = conditons.filter(item => props.newSoa.soaPeriod_data.map(k => k.period_id).includes(item.period_id))
        break;
      case 'Examination':
        activities = conditons.filter(item => props.newSoa.soaPeriod_data.map(k => k.period_id).includes(item.period_id))
        break;
      case 'Procedures':
        activities = conditons.filter(item => props.newSoa.soaPeriod_data.map(k => k.period_id).includes(item.period_id))
        break; 
      case 'Questionnaires':
        activities = conditons.filter(item => props.newSoa.soaPeriod_data.map(k => k.period_id).includes(item.period_id))
        break; 
      case 'StudyProcedures':
        activities = conditons.filter(item => props.newSoa.soaPeriod_data.map(k => k.period_id).includes(item.period_id))
        break;  
      default:
        break;
    }
    return activities;
  }

  const getCondition = (category, cat) => { 
    try {  
    let tmpCategory = [category].slice(0)[0];
    let nVisits = props.newSoa?.soaVisits
    // let vNumber = nVisits.length
    let nWeeks = dayWeekList.map((week, idx)=>{
      return week[soaOncologyFlag?'days':'weeks']
    }); 
    tmpCategory?.forEach((ele) => {
      let _periodType = reOrderVisitsInPeriodType(nVisits, props.newSoa.soaPeriod_data) 
      const _array = _periodType?.flatMap(obj => Array(obj?.no_of_visits)?.fill(obj?.period_id))  
      if((!ele.condition || ele.condition.length==0) || (ele.condition.length < props.newSoa?.soaVisits?.length)){
        let condition = [];
        nVisits?.forEach((e, idx) => {
          condition.push({
            visits: e,
            [soaOncologyFlag?'days':'weeks']:nWeeks && nWeeks[idx],
            modality:ele?.condition?.length >= e ? ele?.condition[e-1]?.modality : '',
            period_id: ele?.condition?.length >= e ? ele?.condition[e-1]?.period_id : _array ? _array[idx] : null,
          });
        });
        const totalVisit = condition?.filter(e=>e.modality && e.modality!=="").length
        ele.condition = condition;
        ele.totalVisit = totalVisit;
      } else if(ele.condition.length > props.newSoa?.soaVisits?.length) {
        let condition =  findConditions(cat, ele.condition) 
        const totalVisit = condition?.filter(e=>e.modality && e.modality!=="").length
        ele.condition = condition;
        ele.totalVisit = totalVisit;
      }
    });
    return tmpCategory
  } catch (error) {  
    console.error("Error in getCondition:", error);  
    return null;  
  }  
  }

  const onEndpointChangeDpndn = (value, option, evt, idx) => { 
    setSelectedEditActivity({...evt, endpoint: [option.evt]}) 
  }

  const handleOkEditActivity = (e, activity) => { 
    setEditActivityModal(false)
    onEndpointChange(activity)
    setSelectedEditActivity(initialActivity) 
    resetAddInsights(true)
  }

  const onEndpointChange = (evt) => {  
    const Categories = evt.Categories
    let tmpCategories, idx, value;
    value = evt.endpoint
    switch (Categories){
      case LABS:
        tmpCategories = labs.slice(0);
        idx = labs.findIndex( k => k['Standard Activity'] == evt['Standard Activity'])
        if(tmpCategories[idx]) {
          tmpCategories[idx].endpoint = value;
        } else {
          tmpCategories.push(evt) 
        }
        setLabs(tmpCategories)
        props.updateSoaActivities({soaAddedLabs : tmpCategories}) 
        break
      case PHYSICAL_EXAMINATION:
        tmpCategories = examination.slice(0);
        idx = examination.findIndex( k => k['Standard Activity'] == evt['Standard Activity'])
        if(tmpCategories[idx]) {
          tmpCategories[idx].endpoint = value;
        } else {
          tmpCategories.push(evt)
        } 
        setExamination(tmpCategories)
        props.updateSoaActivities({soaAddedExamination : tmpCategories}) 
        break
      case PROCEDURES:
        tmpCategories = procedures.slice(0);
        idx = procedures.findIndex( k => k['Standard Activity'] == evt['Standard Activity'])
        if(tmpCategories[idx]) {
          tmpCategories[idx].endpoint = value;
        } else {
          tmpCategories.push(evt)
        }
        setProcedures(tmpCategories)
        props.updateSoaActivities({soaAddedProcedures : tmpCategories}) 
        break
      case QUESTIONNAIRES:
        tmpCategories = questionnaire.slice(0);
        idx = questionnaire.findIndex( k => k['Standard Activity'] == evt['Standard Activity'])
         if(tmpCategories[idx]) {
          tmpCategories[idx].endpoint = value;
        } else {
          tmpCategories.push(evt)
        }
        setQuestionnaire(tmpCategories)
        props.updateSoaActivities({soaAddedQuestionnaires : tmpCategories}) 
        break
      case STUDY_PROCEDURES:
        tmpCategories = studyProcedures.slice(0);
        idx = studyProcedures.findIndex( k => k['Standard Activity'] == evt['Standard Activity'])
        if(tmpCategories[idx]) {
          tmpCategories[idx].endpoint = value;
        } else {
          tmpCategories.push(evt)
        }
        setStudyProcedures(tmpCategories);
        props.updateSoaActivities({soaAddedStudyProcedures : tmpCategories})
        break
      default:
        tmpCategories = labs.slice(0);
        idx = labs.findIndex( k => k['Standard Activity'] == evt['Standard Activity'])
        if(tmpCategories[idx]) {
          tmpCategories[idx].endpoint = value;
        } else {
          tmpCategories.push(evt)
        }
        setLabs(tmpCategories)
        props.updateSoaActivities({soaAddedLabs : setLabs}) 
    }
    props.updateAddedCategory(Categories , tmpCategories);
    props.handleEventChange()
  }

  const updateAllCategories = (condition, Categories,evt, tmpCon) =>{ 

    const totalVisitTmp = condition.filter(c => c.modality && c.modality!=="").length
    switch (Categories) {
      case LABS:
        const tmpLabs = labs.slice(0);
        const targetLab = tmpLabs.find(
          (ele) => ele["Standard Activity"] == evt["Standard Activity"]
        )
        targetLab.condition = tmpCon;        
        targetLab.totalVisit = totalVisitTmp
        setLabs(tmpLabs);
        props.updateSoaActivities({soaAddedLabs : tmpLabs})
        break;

      case PHYSICAL_EXAMINATION:
        const tmpExamination = examination.slice(0);
        const targetEaxm = tmpExamination.find(
          (ele) => ele["Standard Activity"] == evt["Standard Activity"]
        )
        targetEaxm.condition = tmpCon;
        targetEaxm.totalVisit = totalVisitTmp
        setExamination(tmpExamination);
         
        props.updateSoaActivities({soaAddedExamination : tmpExamination})
        break;

      case PROCEDURES:
        const tmpProcedures= procedures.slice(0);
        const targetProcedure = tmpProcedures.find(
          (ele) => ele["Standard Activity"] == evt["Standard Activity"]
        )
        targetProcedure.condition = tmpCon;
        targetProcedure.totalVisit = totalVisitTmp
        setProcedures(tmpProcedures);
        props.updateSoaActivities({soaAddedProcedures : tmpProcedures})
        break;

       case QUESTIONNAIRES:
        const tmpQuestionnaire= questionnaire.slice(0);
        const targetQuestionnaire = tmpQuestionnaire.find(
          (ele) => ele["Standard Activity"] == evt["Standard Activity"]
        )
        targetQuestionnaire.condition = tmpCon;
        targetQuestionnaire.totalVisit = totalVisitTmp
        setQuestionnaire(tmpQuestionnaire); 
        props.updateSoaActivities({soaAddedQuestionnaires : tmpQuestionnaire}) 
        break;

       case STUDY_PROCEDURES:
        const tmpStudyProcedures= studyProcedures.slice(0);
        const targetStudyProcedure=tmpStudyProcedures.find(
          (ele) => ele["Standard Activity"] == evt["Standard Activity"]
        )
        targetStudyProcedure.condition = tmpCon;
        targetStudyProcedure.totalVisit = totalVisitTmp
        setStudyProcedures(tmpStudyProcedures); 
        props.updateSoaActivities({soaAddedStudyProcedures : tmpStudyProcedures})
        break;
      default:
    }

  }

  const onModalityChange = (e,evt, idx,value) => { 

    const { Categories, condition } = evt;
    let tmpCon = condition.slice(0);

    tmpCon[idx].modality = e.target.value
    updateAllCategories(condition, Categories,evt, tmpCon)
  };

  const endpointsSelector = (evt,idx) => {
    return (
      <>
      <Select
        placeholder='Search to Select'
        style={{ width: '100%', height: 37, }} dropdownMatchSelectWidth
        showSearch 
        value={ evt?.endpoint ? evt?.endpoint[0]?.endpoint_std_term: ''}
        onChange={(value, optn)=> onEndpointChangeDpndn(value,optn,evt,idx)}
        virtual={false}
        options={[
          {
            label: 'Primary endpoint', 
            options: trialEndpoints[Object.keys(trialEndpoints)[0]]?.map((k, i) => {
              return {
                label: k.endpoint_std_term,
                value: k.endpoint_std_term,
                key:`${evt.Categories} ${evt['Standard Activity']} ${idx} - ${i} - primary`,
                evt: k
              }
            })
          },
          {
            label: 'Secondary endpoint', 
            options: trialEndpoints[Object.keys(trialEndpoints)[1]]?.map((k, i) => {
              return {
                label: k.endpoint_std_term,
                value: k.endpoint_std_term,
                key:`${evt.Categories} ${evt['Standard Activity']} ${idx} - ${i} - secondary`,
                evt: k
              }
            })
          },
          {
            label: 'Exploratory endpoint', 
            options: trialEndpoints[Object.keys(trialEndpoints)[2]]?.map((k, i) => {
              return {
                label: k.endpoint_std_term,
                value: k.endpoint_std_term,
                key: `${evt.Categories} ${evt['Standard Activity']} ${idx} - ${i} - Exploratory`,
                evt: k
              }
            })
          },
        ]}
      />
    </>
    );
  };

  const getTotalCost = (array) => {
    const totalCost = array
      .filter(currentValue => currentValue['cost'] != undefined)
      .reduce((accumulator, currentValue) => {
        return accumulator + Number(currentValue['cost']) * Number(currentValue['totalVisit']);
      }, 0);
  
    return formatWithCommas(totalCost);
  }

  const onSort = (a,b) => {
    if (sort == "ascend") return (a['cost'] - b['cost'])
    if (sort == "descend") return (b['cost'] - a['cost'])
    return 0
  }

  const onCustomEventNameChange = (e,category, idx,key)=>{
    let temp;
    let value = e.target.value;
    // upper limit 10000
    if(value>10000){value=10000}
    switch (category){
      case LABS:
        temp=labs.slice(0)
        temp[idx][key] = value
        setLabs(temp)
        props.updateSoaActivities({soaAddedLabs : temp})  
        break;

      case PHYSICAL_EXAMINATION:
        temp=examination.slice(0)
        temp[idx][key] = value
        setExamination(temp)
        props.updateSoaActivities({soaAddedExamination : temp}) 
        break;

      case PROCEDURES:
        temp=procedures.slice(0)
        temp[idx][key] = value
        setProcedures(temp)
        props.updateSoaActivities({soaAddedProcedures : temp}) 
        break;

      case QUESTIONNAIRES:
        temp=questionnaire.slice(0)
        temp[idx][key] = value
        setQuestionnaire(temp)
        props.updateSoaActivities({soaAddedQuestionnaires : temp}) 
        break;

      case STUDY_PROCEDURES:
        temp=studyProcedures.slice(0)
        temp[idx][key] = value
        setStudyProcedures(temp)
        props.updateSoaActivities({soaAddedStudyProcedures : temp}) 
        break;
      }
      props.handleEventChange()
  }

  const onRemoveCustomEvent=(category,idx) =>{
    let temp;
    switch (category){
      case LABS:
        temp=labs.slice(0)
        temp.splice(idx,1)
        setLabs(temp)
        props.updateSoaActivities({soaAddedLabs : temp}) 
        break;

        case PHYSICAL_EXAMINATION:
          temp=examination.slice(0)
          temp.splice(idx,1)
          setExamination(temp)
          props.updateSoaActivities({soaAddedExamination : temp}) 
          break;

        case PROCEDURES:
          temp=procedures.slice(0)
          temp.splice(idx,1)
          setProcedures(temp)
          props.updateSoaActivities({soaAddedProcedures : temp}) 
          break;

        case QUESTIONNAIRES:
          temp=questionnaire.slice(0)
          temp.splice(idx,1)
          setQuestionnaire(temp)
          props.updateSoaActivities({soaAddedQuestionnaires : temp}) 
          break;

        case STUDY_PROCEDURES:
          temp=studyProcedures.slice(0)
          temp.splice(idx,1)
          setStudyProcedures(temp)
          props.updateSoaActivities({soaAddedStudyProcedures : temp}) 
          break;
      }
      props.handleEventChange()
  }

  const addPeriodIDtoCondition = (category, periodType) => {    
    const _array = periodType.flatMap(obj => Array(obj.no_of_visits).fill(obj.period_id))      
    category.forEach (cat => {
      const tempCondition = JSON.parse(JSON.stringify(cat.condition))
      tempCondition.map((c, idx) => {
        c.period_id = _array[idx]
        c.visits = idx + 1
        return c
      })
      cat.condition = tempCondition
    })    
    return category
  }

  const reOrderVisitsInPeriodType = (p_visits, p_period_data) => {
    if(!p_period_data) return
    let _newVisits = JSON.parse(JSON.stringify(p_visits)).map((c,i) => c = i + 1)
    let _newNotesArr = JSON.parse(JSON.stringify(props?.newSoa?.soaVisitNotesList))
    let _periodType = JSON.parse(JSON.stringify(p_period_data))
    _periodType?.forEach((period, index) => {
      const visits = _newVisits.splice(0, period.no_of_visits)
      period.visits = visits
      const notes = _newNotesArr.splice(0, period.no_of_visits)
      period.visit_notes = notes
    })
    return _periodType
  }

  const periodNameValidate = () => {  
    return periodType.some(item => item.period_name.length > 500);  
  };

  const onSave = async () => {
    if(periodNameValidate()) {
      message.error('Period name should not exceed more than 500 characters')
      return
    } 
    let _periodType = reOrderVisitsInPeriodType(visits, periodType) 
    setWhetherDraggable(0)
    setWhetherDraggableVisit(0)
    const scheduleOfEvents = {
      "Labs": {
        entities: addPeriodIDtoCondition(labs, _periodType),
        totalCost: getTotalCost(labs)
        },
      "Physical Examination": {
        entities: addPeriodIDtoCondition(examination, _periodType),
        totalCost: getTotalCost(examination)
        },
      "Procedures": {
        entities: addPeriodIDtoCondition(procedures, _periodType),
        totalCost:  getTotalCost(procedures)
        },
      "Questionnaires": {
        entities: addPeriodIDtoCondition(questionnaire, _periodType),
        totalCost: getTotalCost(questionnaire)
        },
      "Study Procedures": {
        entities: addPeriodIDtoCondition(studyProcedures, _periodType),
        totalCost: getTotalCost(studyProcedures)
      },
      "period_data": _periodType,
      "visits": visits.map((c,i) => c = i + 1),
    } 
    props.saveEvents(scheduleOfEvents)

    setRowModality(Object.keys(rowModality).forEach(key => delete rowModality[key]))
    setColumnModality(Object.keys(columnModality).forEach(key => delete columnModality[key]))
  }

  const showConfigureModal = () =>{
    props.showConfigureModal()
  }

  function callback(key) {
    setExpandKeys(key);
    sessionStorage.setItem(`expandKeys_${collapsedId}`, JSON.stringify(key));
  }

  const onColumnModalityChange =(e,idx)=>{
    setColumnModality({ [idx]: e.target.value})
  }

  const updateColumn = (idx) =>{
	let selectedModality = columnModality[idx]!=undefined?columnModality[idx]:''
	let selectedModalityIndex = selectedModality!=undefined && selectedModality!=''?selectedModality-1:''

    const tmpLabs = JSON.parse(JSON.stringify(labs))
	tmpLabs.forEach(criteria => {
		if((selectedModality==''||criteria.modality[selectedModalityIndex]==1) && criteria.condition[idx] && criteria.condition[idx].modality!=""){
			criteria.condition[idx].modality = selectedModality
		}
        criteria.totalVisit = criteria.condition.filter(c => c.modality && c.modality!=="").length
    });
	setLabs(tmpLabs);
  props.updateSoaActivities({soaAddedLabs : tmpLabs}) 

    const tmpExamination = JSON.parse(JSON.stringify(examination))
	tmpExamination.forEach(criteria => {
		if((selectedModality==''||criteria.modality[selectedModalityIndex]==1) && criteria.condition[idx] && criteria.condition[idx].modality!=""){
			criteria.condition[idx].modality = selectedModality
		}
        criteria.totalVisit = criteria.condition.filter(c => c.modality && c.modality!=="").length
    });
	setExamination(tmpExamination);
  props.updateSoaActivities({soaAddedExamination : tmpExamination}) 

    const tmpProcedures = JSON.parse(JSON.stringify(procedures))
	tmpProcedures.forEach(criteria => {
		if((selectedModality==''||criteria.modality[selectedModalityIndex]==1) && criteria.condition[idx] && criteria.condition[idx].modality!=""){
			criteria.condition[idx].modality = selectedModality
		}
        criteria.totalVisit = criteria.condition.filter(c => c.modality && c.modality!=="").length
    });
	setProcedures(tmpProcedures);
  props.updateSoaActivities({soaAddedProcedures : tmpProcedures}) 

    const tmpQuestionnaire = JSON.parse(JSON.stringify(questionnaire))
	tmpQuestionnaire.forEach(criteria => {
		if((selectedModality==''||criteria.modality[selectedModalityIndex]==1) && criteria.condition[idx] && criteria.condition[idx].modality!=""){
			criteria.condition[idx].modality = selectedModality
		}
        criteria.totalVisit = criteria.condition.filter(c => c.modality && c.modality!=="").length
    });
	setQuestionnaire(tmpQuestionnaire);
  props.updateSoaActivities({soaAddedQuestionnaires : tmpQuestionnaire})

    const tmpStudyProcedures = JSON.parse(JSON.stringify(studyProcedures))
	tmpStudyProcedures.forEach(criteria => {
		if((selectedModality==''||criteria.modality[selectedModalityIndex]==1) && criteria.condition[idx] && criteria.condition[idx].modality!=""){
			criteria.condition[idx].modality = selectedModality
		}
        criteria.totalVisit = criteria.condition.filter(c => c.modality && c.modality!=="").length
    });
	setStudyProcedures(tmpStudyProcedures);
  props.updateSoaActivities({soaAddedStudyProcedures : tmpStudyProcedures}) 

	props.handleEventChange()
  }

  const onRowModalityChange =(e,evt)=>{
    setRowModality({ [evt["Standard Activity"]]: e.target.value})
  }

  const onApplyToRow = (evt,fillAll=false) =>{ 
    const { Categories, condition } = evt;
    const endpoint_modality = evt?.endpoint && evt?.endpoint.length > 0 ? evt?.endpoint[0]?.modality !== null? evt?.endpoint[0]?.modality: "" : "" ; 
    let tmpCon = condition.slice(0);
    tmpCon.forEach(element => {
      if(fillAll){
        element.modality= rowModality[evt["Standard Activity"]] ?? endpoint_modality 
      }else{
        element.modality= Boolean(element.modality)? rowModality[evt["Standard Activity"]] ?? endpoint_modality: ''
      }
    });
    updateAllCategories(condition, Categories,evt, tmpCon)
    props.handleEventChange()
  }

  const insertConditionByVisit = (category, idx, whetherCopy:true) => {
    category.forEach (cat => {
      const tempCondition = JSON.parse(JSON.stringify(cat.condition))
      
      const modalityNew = whetherCopy?cat.condition[idx].modality:''
      const modalityNameNew = whetherCopy?cat.condition[idx].modality_name:''
      
      tempCondition.splice(idx+1, 0, {
        visits: null,
        [soaOncologyFlag?'days':'weeks']: null,
        modality: modalityNew,
        modality_name: modalityNameNew,
        period_id: cat.condition[idx].period_id,
      })        
      
      cat.condition = tempCondition
      cat.totalVisit = tempCondition.filter(c => c.modality && c.modality!=="").length
    })
    return category
  }

  const deleteConditionByVisit =(category, idx, step)=> {
        category.forEach(cat => {
        const tempCondition = JSON.parse(JSON.stringify(cat.condition))
        for (let i = 0; i < step; i++) {
          tempCondition.splice(idx, 1)
        }

        cat.condition = tempCondition
        cat.totalVisit = tempCondition.filter(c => c.modality && c.modality!=="").length
      })
    return category
  }
  
  const reorderCondition = (category, activeIndex, overIndex, prevState) => {
    category.forEach (cat => {
      const tempCondition = JSON.parse(JSON.stringify(cat.condition))
      handleDragData(activeIndex, overIndex, tempCondition, prevState)
      // tempCondition.map((c,i) => c.visits = i + 1)
      cat.condition = tempCondition
    })
    return category
  }

  const reorderConditionByVisit = (category, activeIndex, overIndex, prevState) => {
    category.forEach (cat => {
      const tempCondition = JSON.parse(JSON.stringify(cat.condition))
      cat.condition = arrayMove(tempCondition, activeIndex, overIndex)
    })
    return category
  }


  const addConditionByPeriod = (category, item, operateArr, whetherDuplicate) => {
    category.forEach (cat => {
      const tempCondition = JSON.parse(JSON.stringify(cat.condition))
      
      let startIndex = 0;  
      let targetIndex = 0; 
      let movePartLength = 0; 
      let insertIndex = 0;
      let elements = []

      operateArr.slice(0, item.period_order_index-1).forEach(item => {
        const length = item['no_of_visits'];
        startIndex = startIndex + length;
        return startIndex;
      })

      operateArr.slice(0, item.period_order_index).forEach(item => {
        const length = item['no_of_visits'];
        targetIndex = targetIndex + length;
        return targetIndex;
      })
     
      
      // Extract the elements
      movePartLength = item.no_of_visits; 
      elements = tempCondition.slice(startIndex, startIndex+movePartLength);

      if (!whetherDuplicate) {
        elements = JSON.parse(JSON.stringify(elements)).map((item)=>{
          item.modality = ''
          item.modality_name = ''
          return item
        })
      }
      // insertIndex = targetIndex-elements.length; 
      insertIndex = targetIndex; 
      
      tempCondition.splice(insertIndex,0,...elements) 

      tempCondition.map((c,i) => c.visits = i + 1)
      cat.condition = tempCondition
      cat.totalVisit = tempCondition.filter(c => c.modality && c.modality!=="").length
    })
    return category
  }

  const deleteConditionByPeriod = (category, item, operateArr) => {
    category.forEach (cat => {
      const tempCondition = JSON.parse(JSON.stringify(cat.condition))
      
      let startIndex = 0;  
      let targetIndex = 0; 
      let insertIndex = 0;

      operateArr.slice(0, item.period_order_index-1).forEach(item => {
        const length = item['no_of_visits'];
        startIndex = startIndex + length;
        return startIndex;
      })

      operateArr.slice(0, item.period_order_index).forEach(item => {
        const length = item['no_of_visits'];
        targetIndex = targetIndex + length;
        return targetIndex;
      })

      insertIndex = targetIndex-item.no_of_visits; 
      // insertIndex = targetIndex; 
    
      tempCondition.splice(insertIndex,item.no_of_visits) 

      tempCondition.map((c,i) => c.visits = i + 1)
      cat.condition = tempCondition
      cat.totalVisit = tempCondition.filter(c => c.modality && c.modality!=="").length
    })
    return category
  }

  // Reset the visits and weeks of each condition
  const renewCondition = (category, newVisits, newWeeks) => {
    category.forEach (cat => {
      const tempCondition = JSON.parse(JSON.stringify(cat.condition))
      // visits
      tempCondition.map((c,i) => c.visits = newVisits[i])
      // weeks
      if(soaOncologyFlag){
        tempCondition.map((c,i) => c.days = newWeeks[i])
      } else {
        tempCondition.map((c,i) => c.weeks = newWeeks[i])
      }       
      cat.condition = tempCondition
      cat.totalVisit = tempCondition.filter(c => c.modality && c.modality!=="").length
    })
    return category
  }

  const addVisits = ((idx, whetherCopy)=>{
    setVisitsShowOnly((prevState) => {
      const activeIndex = prevState.findIndex((i) => i.unique_id === visitsShowOnly[idx].unique_id);
      const overIndex = prevState.findIndex((i) => i.unique_id === visitsShowOnly[idx].unique_id);

      // 1 - update periodType 
      let newPeriodType = JSON.parse(JSON.stringify(periodType))
      let {moveIndex,targetIndex} = moveItemInArrayByIndices(newPeriodType, activeIndex, overIndex);  
    
      newPeriodType[targetIndex].no_of_visits = newPeriodType[targetIndex].no_of_visits + 1 

      // 2 - update visits  - 'visits' 
      let newVisits = visits.slice(0)
      const visitNew = Math.max(...newVisits)+1
      // newVisits[activeIndex]
      newVisits.splice(overIndex+1, 0, visitNew)
      setVisits(newVisits);                  

      // 3- update weeks 
      let newWeeks = dayWeekList.map((week, idx)=>{
        return week[soaOncologyFlag?'days':'weeks']        
      })
      const weekNew = whetherCopy?newWeeks[activeIndex]:null
      newWeeks.splice(overIndex+1, 0, weekNew)        

      // 4- update notes
      let notesArr = props?.newSoa?.soaVisitNotesList.map(note => note||'')
      // const notesNew = whetherCopy?notesArr[activeIndex]:''
      const notesNew = ''
      notesArr.splice(overIndex+1, 0, notesNew)
      // setNotesList(notesArr)        
      props.visitNoteListHandler(notesArr);   

      // 5- update periodType according to the new visits weeks and visit_notes
      let _newVisits = JSON.parse(JSON.stringify(newVisits))
      let _newWeeks = JSON.parse(JSON.stringify(newWeeks))
      let _newNotesArr = JSON.parse(JSON.stringify(notesArr))

      newPeriodType.forEach((period, index) => {
        const visits = _newVisits.splice(0, period.no_of_visits)
        const weeks = _newWeeks.splice(0, period.no_of_visits)            
        const visit_notes = _newNotesArr.splice(0, period.no_of_visits)
        period.visits = visits
        if(soaOncologyFlag){
          period.days = weeks
        } else {
          period.weeks = weeks
        }
        period.visit_notes = visit_notes
      }
      )          
      setPeriodType(newPeriodType)
      newPeriodType = incrementVisit(newPeriodType)

      props.updateSoaActivities({
        soaPeriod_data:  newPeriodType,
        soaVisits: newVisits.map((c,i) => c = i + 1),
      }) 

      // 6- update conditions
      let tmp_labs = insertConditionByVisit(labs, overIndex, whetherCopy) 
      let tmp_examination = insertConditionByVisit(examination, overIndex, whetherCopy) 
      let tmp_procedures = insertConditionByVisit(procedures, overIndex, whetherCopy) 
      let tmp_questionnaire = insertConditionByVisit(questionnaire, overIndex, whetherCopy) 
      let tmp_studyProcedures = insertConditionByVisit(studyProcedures, overIndex, whetherCopy) 

      const tempVisitArray = newVisits.map((c,i) => c = i + 1)
      tmp_labs = renewCondition(tmp_labs,tempVisitArray, newWeeks)
      tmp_examination = renewCondition(tmp_examination,tempVisitArray, newWeeks)
      tmp_procedures = renewCondition(tmp_procedures,tempVisitArray, newWeeks)
      tmp_questionnaire = renewCondition(tmp_questionnaire,tempVisitArray, newWeeks)
      tmp_studyProcedures = renewCondition(tmp_studyProcedures,tempVisitArray, newWeeks)
      
      setLabs(tmp_labs)
      setExamination(tmp_examination)
      setProcedures(tmp_procedures)
      setQuestionnaire(tmp_questionnaire)
      setStudyProcedures(tmp_studyProcedures )
      props.updateSoaActivities({soaAddedLabs : tmp_labs}) 
      props.updateSoaActivities({soaAddedExamination : tmp_examination}) 
      props.updateSoaActivities({soaAddedProcedures : tmp_procedures}) 
      props.updateSoaActivities({soaAddedQuestionnaires : tmp_questionnaire}) 
      props.updateSoaActivities({soaAddedStudyProcedures : tmp_studyProcedures})

      // return the updated 'visitsShowOnly' 
      let newVisitsShowOnly = JSON.parse(JSON.stringify(prevState))
      let newItem = JSON.parse(JSON.stringify(prevState))[activeIndex]
      
      // Find the maximum unique_id value and assign a new unique_id to the new item
      const maxId = Math.max(...newVisitsShowOnly.map(item => item.unique_id))  
      newItem.unique_id = maxId + 1

      newVisitsShowOnly.splice(overIndex+1, 0, newItem)      
      newVisitsShowOnly = newVisitsShowOnly.map((visitValue, index) => {
        return {
          "unique_id": visitValue.unique_id,
          "order": index + 1,
          "value": visitValue.value,
        }
      }) 
      return newVisitsShowOnly;      
    });
  })

  const deleteVisits = ((idx)=>{
    setVisitsShowOnly((prevState) => {
      const activeIndex = prevState.findIndex((i) => i.unique_id === visitsShowOnly[idx].unique_id);
      const overIndex = prevState.findIndex((i) => i.unique_id === visitsShowOnly[idx].unique_id);

      // 1 - update periodType 
      let newPeriodType = JSON.parse(JSON.stringify(periodType))
      let {moveIndex, targetIndex} = moveItemInArrayByIndices(newPeriodType, activeIndex, overIndex);  
    
      if(newPeriodType[targetIndex].no_of_visits === 1){
        message.error('There is only one visit under this period. You cannot delete it.')
        return prevState
      } else {
        newPeriodType[targetIndex].no_of_visits = newPeriodType[targetIndex].no_of_visits - 1 

        // 2 - update visits  - 'visits' 
        let newVisits = visits.slice(0)
        newVisits.splice(overIndex, 1)
        setVisits(newVisits);                  
  
        // 3- update weeks 
        let newWeeks = dayWeekList.map((week, idx)=>{
          return week[soaOncologyFlag?'days':'weeks']        
        })
        newWeeks.splice(overIndex, 1)        
  
        // 4- update notes
        let notesArr = props?.newSoa?.soaVisitNotesList.map(note => note||'')
        notesArr.splice(overIndex, 1)
        // setNotesList(notesArr)        
        props.visitNoteListHandler(notesArr);   
  
        // 5- update periodType according to the new visits weeks and visit_notes
        let _newVisits = JSON.parse(JSON.stringify(newVisits))
        let _newWeeks = JSON.parse(JSON.stringify(newWeeks))
        let _newNotesArr = JSON.parse(JSON.stringify(notesArr))
  
        newPeriodType.forEach((period, index) => {
          const visits = _newVisits.splice(0, period.no_of_visits)
          const weeks = _newWeeks.splice(0, period.no_of_visits)            
          const visit_notes = _newNotesArr.splice(0, period.no_of_visits)
          period.visits = visits
          if(soaOncologyFlag){
            period.days = weeks
          } else {
            period.weeks = weeks
          }
          period.visit_notes = visit_notes
        }
        )  
        newPeriodType = incrementVisit(newPeriodType)        
        setPeriodType(newPeriodType)
        props.updateSoaActivities({
          soaPeriod_data:  newPeriodType,
          soaVisits: newVisits.map((c,i) => c = i + 1),
        })  
  
        // 6- update conditions
        let tmp_labs = deleteConditionByVisit(labs, overIndex, 1) 
        let tmp_examination = deleteConditionByVisit(examination, overIndex, 1) 
        let tmp_procedures = deleteConditionByVisit(procedures, overIndex, 1) 
        let tmp_questionnaire = deleteConditionByVisit(questionnaire, overIndex, 1) 
        let tmp_studyProcedures = deleteConditionByVisit(studyProcedures, overIndex, 1) 
  
        const tempVisitArray = newVisits.map((c,i) => c = i + 1)
        tmp_labs = renewCondition(tmp_labs,tempVisitArray, newWeeks)
        tmp_examination = renewCondition(tmp_examination,tempVisitArray, newWeeks)
        tmp_procedures = renewCondition(tmp_procedures,tempVisitArray, newWeeks)
        tmp_questionnaire = renewCondition(tmp_questionnaire,tempVisitArray, newWeeks)
        tmp_studyProcedures = renewCondition(tmp_studyProcedures,tempVisitArray, newWeeks)
        
        setLabs(tmp_labs)
        setExamination(tmp_examination)
        setProcedures(tmp_procedures)
        setQuestionnaire(tmp_questionnaire)
        setStudyProcedures(tmp_studyProcedures )
        props.updateSoaActivities({soaAddedLabs : tmp_labs}) 
        props.updateSoaActivities({soaAddedExamination : tmp_examination}) 
        props.updateSoaActivities({soaAddedProcedures : tmp_procedures}) 
        props.updateSoaActivities({soaAddedQuestionnaires : tmp_questionnaire}) 
        props.updateSoaActivities({soaAddedStudyProcedures : tmp_studyProcedures})
  
        // return the updated 'visitsShowOnly' 
        let newVisitsShowOnly = JSON.parse(JSON.stringify(prevState))
        newVisitsShowOnly.splice(overIndex+1, 1)      
        newVisitsShowOnly = newVisitsShowOnly.map((visitValue, index) => {
          return {
            "unique_id": visitValue.unique_id,
            "order": index + 1,
            "value": visitValue.value,
          }
        }) 
        
        return newVisitsShowOnly;   
      }
        
    });
  })

  // Add visit
  const insertColumn=((idx)=>{  
    addVisits(idx, false)  
  })

  // Delete visit
  const deleteColumn=((idx)=>{
    deleteVisits(idx)
  })

  // Duplicate visit
  const duplicateColumn=((idx)=>{
    addVisits(idx, true)
  })

  // Move visit
  const moveColumn=((idx)=>{    
    setWhetherDraggableVisit(visitsShowOnly[idx].unique_id)
  })

  const incrementVisit = (period_array) => {  
    let updated = [...period_array];  
    let totalVisits = updated.reduce((sum, period) => sum + period.no_of_visits, 0);  
      
    let visitCount = 0;  
    updated.forEach((period) => {  
      period.visits = Array.from({ length: period.no_of_visits }, () => ++visitCount);  
    });  
      
    return updated;  
  };  

  const insertPeriod=((idx)=>{
     const data = [...periodType]
     const prevPeriod = data[data.findIndex((i) => i.period_id === idx)]
     const day_week_selection = soaOncologyFlag ? 'days' : 'weeks';
     const maxVisit = Math.max(...visits)
     const visit_arr = Array.from({ length: prevPeriod?.no_of_visits }, (v, i) => i + maxVisit + 1);
     const week_arr = Array.from({ length: prevPeriod?.no_of_visits }, () => null);
     const notes_arr = Array.from({ length: prevPeriod?.no_of_visits }, () => '');  
    //  const maxPeriodID = Math.max(...data.map((c,i) => c.period_id)) 
     const initialVisit = {
      "period_name": toSentenceCase(prevPeriod?.visit_type),
      "period_id": "",
      "period_order_index": "",
      "no_of_visits": prevPeriod?.no_of_visits,
      "visit_type_id":  prevPeriod?.visit_type_id,
      "visit_type":  prevPeriod?.visit_type,
      "visits": visit_arr,
      "visit_notes": notes_arr,
      [day_week_selection]:week_arr 
    }
    data.splice(idx, 0, initialVisit);  
    let updatedArr = data.map( (item, index)=> (({...item, period_order_index: index+1, period_id: index+1}))) 
    updatedArr = incrementVisit(updatedArr)
    setPeriodType(updatedArr);
    const _visits = updatedArr?.map(item => item?.visits).flat();  
    props.updateSoaActivities({
      soaPeriod_data:updatedArr,
      soaVisits: _visits.map((c,i) => c = i + 1),
      // soaWeeks: weeks, 
    }) 

    // const notesArr = updatedArr?.map(item => item?.visit_notes).flat();
    // props.visitNoteListHandler(notesArr); 

    // update weeks
    let arr = [];  
    const prop = soaOncologyFlag ? 'days' : 'weeks';   
    updatedArr.forEach(item => {  
      const propData = item[prop];  
      if (propData && propData.length > 0) {  
        propData.forEach(k => {  
          arr.push({  
            ...item,  
            period_name: item.period_name,  
            period_order_index: item.period_order_index,  
            [prop]: k  
          });  
        });  
      }  
    }); 
    const newWeeks = arr.map((week, idx)=>{
      return week[soaOncologyFlag?'days':'weeks']
    })
    
    // update all conditions
    let tmp_labs = addConditionByPeriod(labs,prevPeriod, data, false) 
    let tmp_examination = addConditionByPeriod(examination,prevPeriod, data, false) 
    let tmp_procedures = addConditionByPeriod(procedures,prevPeriod, data, false) 
    let tmp_questionnaire = addConditionByPeriod(questionnaire,prevPeriod, data, false) 
    let tmp_studyProcedures = addConditionByPeriod(studyProcedures,prevPeriod, data, false) 

    tmp_labs = renewCondition(tmp_labs,_visits.map((c,i) => c = i + 1), newWeeks)
    tmp_examination = renewCondition(tmp_examination,_visits.map((c,i) => c = i + 1), newWeeks)
    tmp_procedures = renewCondition(tmp_procedures,_visits.map((c,i) => c = i + 1), newWeeks)
    tmp_questionnaire = renewCondition(tmp_questionnaire,_visits.map((c,i) => c = i + 1), newWeeks)
    tmp_studyProcedures = renewCondition(tmp_studyProcedures,_visits.map((c,i) => c = i + 1), newWeeks)

    setLabs( tmp_labs )
    setExamination( tmp_examination)
    setProcedures( tmp_procedures)
    setQuestionnaire( tmp_questionnaire)
    setStudyProcedures( tmp_studyProcedures )

    props.updateSoaActivities({soaAddedLabs : tmp_labs}) 
    props.updateSoaActivities({soaAddedExamination : tmp_examination}) 
    props.updateSoaActivities({soaAddedProcedures : tmp_procedures}) 
    props.updateSoaActivities({soaAddedQuestionnaires : tmp_questionnaire}) 
    props.updateSoaActivities({soaAddedStudyProcedures : tmp_studyProcedures})
  })

  const deletePeriod=((idx)=>{ 
    const data = [...periodType]
    if(data.length == 1) return;
    let removedData = data.filter( k => k.period_id !== idx).map( (item, index)=> (({...item, period_order_index: index+1, period_id: index+1}))) 
    removedData =  incrementVisit(removedData)
    setPeriodType(removedData);
    
    const _visits = removedData?.map(item => item?.visits).flat();  
    props.updateSoaActivities({
      soaPeriod_data:removedData,
      soaVisits: _visits.map((c,i) => c = i + 1),
      // soaWeeks: weeks, 
    }) 

     // update weeks
     let arr = [];  
     const prop = soaOncologyFlag ? 'days' : 'weeks';   
     removedData.forEach(item => {  
       const propData = item[prop];  
       if (propData && propData.length > 0) {  
         propData.forEach(k => {  
           arr.push({  
             ...item,  
             period_name: item.period_name,  
             period_order_index: item.period_order_index,  
             [prop]: k  
           });  
         });  
       }  
     }); 
     const newWeeks = arr.map((week, idx)=>{
       return week[soaOncologyFlag?'days':'weeks']
     })     
     
     // update all conditions
     const prevPeriod = data[data.findIndex((i) => i.period_id === idx)]
     
     let tmp_labs = deleteConditionByPeriod(labs, prevPeriod, data) 
     let tmp_examination = deleteConditionByPeriod(examination, prevPeriod, data) 
     let tmp_procedures = deleteConditionByPeriod(procedures, prevPeriod, data) 
     let tmp_questionnaire = deleteConditionByPeriod(questionnaire, prevPeriod, data) 
     let tmp_studyProcedures = deleteConditionByPeriod(studyProcedures, prevPeriod, data)      

     tmp_labs = renewCondition(tmp_labs,_visits.map((c,i) => c = i + 1), newWeeks)
     tmp_examination = renewCondition(tmp_examination,_visits.map((c,i) => c = i + 1), newWeeks)
     tmp_procedures = renewCondition(tmp_procedures,_visits.map((c,i) => c = i + 1), newWeeks)
     tmp_questionnaire = renewCondition(tmp_questionnaire,_visits.map((c,i) => c = i + 1), newWeeks)
     tmp_studyProcedures = renewCondition(tmp_studyProcedures,_visits.map((c,i) => c = i + 1), newWeeks)
 
     setLabs( tmp_labs )
     setExamination( tmp_examination)
     setProcedures( tmp_procedures)
     setQuestionnaire( tmp_questionnaire)
     setStudyProcedures( tmp_studyProcedures )

     props.updateSoaActivities({soaAddedLabs : tmp_labs}) 
     props.updateSoaActivities({soaAddedExamination : tmp_examination}) 
     props.updateSoaActivities({soaAddedProcedures : tmp_procedures}) 
     props.updateSoaActivities({soaAddedQuestionnaires : tmp_questionnaire}) 
     props.updateSoaActivities({soaAddedStudyProcedures : tmp_studyProcedures})
  })

  const duplicatePeriod=((data)=>{
    let item = JSON.parse(JSON.stringify(data))
    setPeriodType((prevState) => {
      const temp = visits.slice(0)
      const maxVisit = Math.max(...temp)
      const newVisit = Array.from({ length: item.no_of_visits }, (v, i) => i + maxVisit + 1);
	    temp.splice(item.period_order_index,0,...newVisit) 
      // setVisits(temp)
      setVisitsShowOnly(temp.map((item, index) => {
        return {
          "unique_id": index + 1,
          "order": index + 1,
          "value": item,
        }
      }))
      
    // update weeks
    const newWeeks = dayWeekList.map((week, idx)=>{
      return week[soaOncologyFlag?'days':'weeks']
    })

    if(soaOncologyFlag){
      newWeeks.splice(item.period_order_index,0,...item.days)   
    } else {
      newWeeks.splice(item.period_order_index,0,...item.weeks)
    }   

    // return the updated 'periodType' 
    const newItem = JSON.parse(JSON.stringify(item))
    newItem.period_id = prevState.length + 1
    // clear notes to avoid duplication
    newItem.visit_notes = Array.from({ length: item.no_of_visits }, (v, i) => '')
    prevState.splice(item.period_order_index,0,newItem) 
    let newPeriodType = JSON.parse(JSON.stringify(prevState))
    const arr = temp
    newPeriodType.map((period, index) => {
      period.period_id = index + 1
      period.period_order_index = index + 1
      const visits = arr.splice(0, period.no_of_visits)
      period.visits = visits      
      return period
    })    
    newPeriodType =  incrementVisit(newPeriodType)
    setVisits(newPeriodType.map(k => k.visits).flat())
    // update all conditions
    let tmp_labs = addConditionByPeriod(labs,item, prevState, true) 
    let tmp_examination = addConditionByPeriod(examination,item, prevState, true) 
    let tmp_procedures = addConditionByPeriod(procedures,item, prevState, true) 
    let tmp_questionnaire = addConditionByPeriod(questionnaire,item, prevState, true) 
    let tmp_studyProcedures = addConditionByPeriod(studyProcedures,item, prevState, true) 

    tmp_labs = renewCondition(tmp_labs,newPeriodType.map(k => k.visits).flat(), newWeeks)
    tmp_examination = renewCondition(tmp_examination,newPeriodType.map(k => k.visits).flat(), newWeeks)
    tmp_procedures = renewCondition(tmp_procedures,newPeriodType.map(k => k.visits).flat(), newWeeks)
    tmp_questionnaire = renewCondition(tmp_questionnaire,newPeriodType.map(k => k.visits).flat(), newWeeks)
    tmp_studyProcedures = renewCondition(tmp_studyProcedures,newPeriodType.map(k => k.visits).flat(), newWeeks)

    

    setLabs(  tmp_labs )
    setExamination(tmp_examination)
    setProcedures( tmp_procedures)
    setQuestionnaire( tmp_questionnaire)
    setStudyProcedures( tmp_studyProcedures )

    props.updateSoaActivities({soaAddedLabs : tmp_labs}) 
    props.updateSoaActivities({soaAddedExamination : tmp_examination}) 
    props.updateSoaActivities({soaAddedProcedures : tmp_procedures}) 
    props.updateSoaActivities({soaAddedQuestionnaires : tmp_questionnaire}) 
    props.updateSoaActivities({soaAddedStudyProcedures : tmp_studyProcedures})

    props.updateSoaActivities({
      soaPeriod_data:  newPeriodType,
      soaVisits: newPeriodType.map(k => k.visits).flat(),
    })

    // const notesArr = newPeriodType?.map(item => item?.visit_notes).flat();
    // props.visitNoteListHandler(notesArr); 
    return newPeriodType;
    });
  })

  const movePeriod=((idx)=>{
    setWhetherDraggable(idx)
    
  })

  const periodNameChangeHandler = (e, periodId, periodName) => { 
    let value = e.target.value 
    const periodData = [...periodType] 
    const period_data_updated = periodData.map( item => {
      if(item.period_id == periodId && item.period_name == periodName) {
          item.period_name = value
      }
      return item
  })
    setPeriodType(period_data_updated)
    props.updateSoaActivities({
      soaPeriod_data:period_data_updated
    })
  }
  
  function DraggableItem(props) {
    const { printContent, item } = props;
    const {
      attributes,
      listeners,
      setNodeRef,
      transform,
      transition,
      isDragging,
    } = useSortable({id: item.period_id, disabled: whetherDraggable !== item.period_id});
  
    let content  = item?.no_of_visits
    let width = 1
    width = content > 0 ? content : 1; 

    const style = {
      transform: CSS.Transform.toString(transform),
      transition,
      cursor: `${whetherDraggable !== item.period_id? 'default' : 'move'}`,
      fontSize: width !== 1?'10px':'8px', 
      flex:`${width} 0`,
      minWidth: width !== 1?`${41*width}px`:'41px',
     touchAction: 'none',
      display: 'flex',
      justifyContent: 'space-between',
      lineHeight: '15px',
      border: `3px solid ${colorList[colorList.findIndex((i) => i.visit_type_id === item.visit_type_id)]?.color}`,
      margin: '0 1px 0 1px',
      backgroundColor:`${item.visit_type === currentVisitTypes || currentVisitTypes === 'total_trial' ? '#FFF' : '#DEDEDE'}`
    };
  
    return (
      <div className="td" id={item.period_id} ref={setNodeRef} key={item.period_id} style={style} {...attributes} {...listeners}>
        <MenuOutlined style={{fontSize: '11px',marginTop: '3px', marginLeft: '5px', color: `${whetherDraggable !== item.period_id? 'transparent' : 'black'}`,}}/> 
        <Tooltip title={item.period_name}> 
          <Input className="td cell-input periodNameInput" 
         style={{fontSize: "14px",backgroundColor:`${item.visit_type === currentVisitTypes || currentVisitTypes === 'total_trial'? '#FFF' : '#DEDEDE'}`}} 
         key={`period_${item?.period_id}`} 
         defaultValue={item.period_name}  
         onBlur={(e) => periodNameChangeHandler(e, item.period_id, item.period_name)}
        />
        </Tooltip> 
        <Tooltip
          title={
            <PeriodsList
              idx={item.period_id}
              item={item}
              insertPeriod={insertPeriod}
              deletePeriod={deletePeriod}
              duplicatePeriod={duplicatePeriod}
              movePeriod={movePeriod}
            />
          }
          color="#ffffff"
          // trigger="click"
          mouseEnterDelay={0.2}
        >
        <MoreOutlined style={{fontSize: '16px',marginTop: '1px'}} onClick={(e) => e.stopPropagation()}/>
        </Tooltip>
      </div>
    );
  }

  function DraggableVisit(props) {
    const { item } = props;
    const {
      attributes,
      listeners,
      setNodeRef,
      transform,
      transition,
      isDragging,
    } = useSortable({id: item.unique_id, disabled: whetherDraggableVisit !== item.unique_id});

    const style = {
      transform: CSS.Transform.toString(transform),
      transition,
      cursor: `${whetherDraggableVisit !== item.unique_id? 'default' : 'move'}`,
      touchAction: 'none',
    };
    return (
      <div 
      className="td num-cell"  
      id={item.unique_id}
      ref={setNodeRef}  
      style={{...style,
        // backgroundColor: "#FFF",
        display: 'flex',
        flexDirection: 'column',
        paddingTop: 0,
        backgroundColor:`${currentVisitIndex.includes(item.order)? '#FFF' : '#DEDEDE'}`
      }} 
      key={item.unique_id}
      {...attributes} 
      {...listeners}
      >
        <MenuOutlined style={{fontSize: '8px',marginTop: '0px', marginLeft: '0px', color: `${whetherDraggableVisit !== item.unique_id? 'transparent' : 'black'}`,}}/>
        <span style={{fontSize: '14px',marginTop: '-2px'}}>{item?.order}</span>
      </div>
    );
  }

  // const dctSelected = (evt) => evt?.endpoint[0]? evt?.endpoint[0]?.modality : null
  const dctSelected = (evt) => {
    const endpointModality = evt?.endpoint[0]?.modality;
    return endpointModality !== undefined && evt?.modality[endpointModality - 1] === 1 ? endpointModality : null;
  };
  const ModalityList = (props) =>{ 
  const {evt,idx,value,rowModality,columnModality} = props;
  const endpoint_modality =  evt?.endpoint && evt?.endpoint.length > 0 ? dctSelected(evt): null
    return(
      <div className="modality-list-container">
        <CloseCircleOutlined />
        <Radio.Group
        onChange={props.isRowBatch?(e)=>onRowModalityChange(e,evt): props.isColumnBatch?(e)=>onColumnModalityChange(e,idx): (e)=>onModalityChange(e,evt,idx,value)}
        value={
          props.isRowBatch?
          rowModality[evt['Standard Activity']] ?? endpoint_modality:
          props.isColumnBatch?
          (columnModality[idx]) :
          Number(value)
        }
        >
        <Space direction="vertical">
        {(props.isColumnBatch ||  props.isRowBatch ) && modalityOptions.map( (m,idx)=>{
            return (
              <div className="modality-item" key={idx}>
              <Radio
              value={m.key}
              disabled={evt?.modality&&evt.modality[idx]==0?true:false
              }>
                <img src={m.icon} alt="" style ={{ backgroundColor: m.color, 
                borderRadius: '50%',
                marginRight: m.name !== "Clear" ? '2px' : '0px',
                }}/> 
                {m.name.length > 0 ? (m.name === "eConsent" ? "eConsent"  : toSentenceCase(m.name)) : "Clear"}
              </Radio>
            </div>
            )
        })}
        {!props.isColumnBatch && !props.isRowBatch && modalityOptions.map( (m,idx)=>{
            return (
              <div className="modality-item" key={idx}>
              <Radio
              value={m.key}
              disabled={evt?.modality&&evt.modality[idx]==0?true:false
              }>
                <img src={m.icon} alt="" style= {{
                  backgroundColor: m.color, 
                  borderRadius: '50%',
                  marginRight: m.name !== "Clear" ? '2px' : '0px',
                }} /> 
                  
                {m.name.length > 0 ? (m.name === "eConsent" ? "eConsent"  : toSentenceCase(m.name)) : "Clear"}
              </Radio>
            </div>
            )
        })}
        </Space>
      </Radio.Group>
      {
        props.isColumnBatch&&(
          <div className="action-group">
            <div className="whole action" onClick={()=>updateColumn(idx)}>Update Selected Activities</div>
            {/* <div className="batch action" onClick={()=>onOptimize(idx)}>Optimize to Align</div> */}
            <div className="insert-column action" onClick={()=>insertColumn(idx)}>
              <PlusCircleOutlined className="little-icon"/>
              Add Visit
            </div>
            {visits.length>1 ? (
               <div className="insert-column action" onClick={()=>deleteColumn(idx)}>
                <MinusCircleOutlined className="little-icon"/>
                Delete Visit
              </div>
            ): (
                <div className="insert-column action is-disabled" onClick={()=>deleteColumn(idx)}>
                  <MinusCircleOutlined className="little-icon"/>
                  Delete Visit
                </div>
            )}
            <div className="insert-column action" onClick={()=>duplicateColumn(idx)}>
            <CopyOutlined className="little-icon"/>
            Duplicate Visit
          </div>
          <div className="insert-column action" onClick={()=>moveColumn(idx)}>
            <MenuOutlined className="little-icon"/>
            Move
          </div>
          </div>
        )
      }
      {
        props.isRowBatch && (
        <div className="action-group">
          <div className="whole action" onClick={()=>onApplyToRow(evt)}>Update Selected Visits</div>
          <div className="batch action" onClick={()=>onApplyToRow(evt,true)}>Update All Visits</div>
        </div>
        )
      }
      </div>
    )
  }

  const onVisitTypeChange = (evt, indx) => { 
    const data = [...periodType]
    const value = evt.target.value;
    const visitsDetail = visitTypes.find(k => k.visit_type == value)
    const visit_type_updated = data.map( item => {
      if(item.period_id == indx) {
          item.visit_type = value
          item.visit_type_id = visitsDetail.visit_type_id
      }
      return item
  })
    setPeriodType(visit_type_updated)
    props.updateSoaActivities({
      soaPeriod_data:  visit_type_updated 
    }) 
  }

  const PeriodsList = (props) =>{ 
    const {idx, item} = props; 
    const data = periodType.find( item => item.period_id == idx);
    return(
      <div className="period-list-container">
        <div className="insert-column action no-border" onClick={()=>props.insertPeriod(idx)}>
          <AppstoreAddOutlined rotate={270} className="little-icon"/>
          Period Type
        </div>
        <Radio.Group
         
        // value={}
        >
        <Space direction="vertical">
        <Radio.Group  onChange={(e)=>onVisitTypeChange(e,idx)} defaultValue={data?.visit_type}>   
          { visitTypes.map( (item,idx)=>{
            return (
              <div className="period-item" key={idx}>
              <Radio
              name={item?.visit_type_id}
              value={item?.visit_type} 
              style={{marginLeft: '20px'}}
              >
                {toSentenceCase(item.visit_type)}
              </Radio>
            </div>
            )
        })}
      </Radio.Group>     
        </Space>
      </Radio.Group>
        <div className="action-group">
          <div className="insert-column action" onClick={()=>props.insertPeriod(idx)}>
            <PlusCircleOutlined className="little-icon"/>
            Add Period
          </div>
          {periodType.length>1 ? (
              <div className="insert-column action" onClick={()=>props.deletePeriod(idx)}>
                <MinusCircleOutlined className="little-icon"/>
                Delete Period
              </div>
          ): (
              <div className="insert-column action is-disabled" onClick={()=>props.deletePeriod(idx)}>
               <MinusCircleOutlined className="little-icon"/>
                Delete Period
            </div>
          )}
          <div className="insert-column action" onClick={()=>props.duplicatePeriod(item)}>
            <CopyOutlined className="little-icon"/>
            Duplicate Period
          </div>
          <div className="insert-column action" onClick={()=>props.movePeriod(idx)}>
            <MenuOutlined className="little-icon"/>
            Move Period
          </div>
        </div>
      </div>
    )
  }

  const editSoaDetails = (e, evt, idx) => { 
    setEditActivityModal(true) 
    setSelectedEditActivity({...evt})
  }

  const clickHandler = (e, evt, idx) => {
    e.stopPropagation();   
    const { Categories, condition } = evt;
    let tmpCon = condition.slice(0);
    tmpCon[idx].modality = 8
    updateAllCategories(condition, Categories,evt, tmpCon)
  }

  const handleCancelEditActivity = () => {
    setEditActivityModal(false) 
    setSelectedEditActivity(initialActivity) 
    resetAddInsights(false)
  }
  
  const generatePanel = (panelData) => {
    const { key, type, data } = panelData;

    const name = `${type} (${data.length})`
    // const cost = getTotalCost(data)
    const cost = props.newSoa?.scenarios&&props.newSoa?.scenarios[0]['Schedule of Activities']?.CostData&&props.newSoa?.scenarios[0]['Schedule of Activities']?.CostData.find(c => c?.name === type)?.value
    
    return (
      <Panel
        className="collapse-container"
        forceRender={true}
        header={
          <div className="event-panel-head">
            <div className="event-title e-row">
              <div className= {`name ${!showMetrics ? 'show-metrics-name' : 'hide-metrics-name'}`}>
                <span style={{ width: "186px", display: "inline-block" }}>
                  {name}
                </span>

                {!viewOnly && <span className="add-event" ></span>}
              </div>
              <div className="cost">
                $ {cost}
              </div>
              <div></div>
            </div>
            <div className="event-title-right"></div>
          </div>
        }
        key={key}
      >
        <div className="shedule-of-event-panel-body">
          {data.sort((a, b) => {
            return onSort(a, b)
          })
            .map((evt, idx) => {
              return (
                <div className="event-item" key={`${type.toLowerCase()}_${idx}`}>
                  <div className="events-wrapper e-row" style={{ position: "sticky", backgroundColor: "#FFF", left: 0, top: 0, zIndex: 99, width: !showMetrics? '450px':'691px'}}>
                    <div style={{width: showMetrics ? soaOncologyFlag ?"332px": "230px" : "400px"}} className={`${evt.Custom ? "custom-event " : ""}my-event-td td f-3`}>
                    
                      {
                        viewOnly ? evt["Standard Activity"] : (
                          <>
                            {
                              !evt.Custom ? (
                                <Tooltip title={evt["Standard Activity"]}>
                                <DeleteFilled style={{ color: '#BABABA', marginRight: '5px',position: 'relative', top: '-3px'}} onClick={() => props.handleEvent(evt)} />
                                  {evt["Standard Activity"]}
                                </Tooltip>
                                
                            
                              ) : (
                                <>
                                  <MinusCircleOutlined onClick={() => onRemoveCustomEvent(LABS, idx)} /> <Input value={evt["Standard Activity"]} onChange={(e) => onCustomEventNameChange(e, LABS, idx, "Standard Activity")} />
                                </>
                              )
                            }
                          </>
                        )
                      }
                    </div>
                    {showMetrics && (
                      <>
                    <div className= {`${soaOncologyFlag ? "td f2-oncology" : "frequency-td td f-2"}`} 
                    style={{ 
                      display: 'flex',
                     justifyContent: 'left', 
                      alignItems: 'center',
                    
                    }}>

                      <span>{Math.round(evt.Frequency * 10000) / 100 + "%"}</span>
                    </div>
                    {!soaOncologyFlag && (
                      <>
                        <div className="visit-td td f-2" style={{ display: 'flex', justifyContent: 'left', alignItems: 'center' }}>
                          <span>{evt?.visit_frequency !== null && evt?.visit_frequency !== "NA" ? Math.round(evt.visit_frequency * 100) / 100 + "%" : 'NA'} </span>

                        </div>
                        <div className="screening-frequency-td td f2" style={{ display: 'flex', justifyContent: 'left', alignItems: 'center' }}>
                          {!soaOncologyFlag? Math.floor(evt.totalVisit / (visits.length) * 10000) / 100 + "%" : 'NA'}
                        </div>
                      </>
                    )}
                    <div className= {`${soaOncologyFlag ? "td cost-td-oncology" : "cost-td td f-2-small"}`}
                    style={{ display: 'flex', justifyContent: 'left', alignItems: 'center' }} > 
                      {
                        viewOnly ? evt["cost"] == null ? `` : `$ ${evt["cost"]}` : (
                          <>
                            {
                              !evt.Custom ? evt["cost"] == null ? `` : `$${evt["cost"]}` : <>$ <Input value={evt["cost"]} type="number" onChange={(e) => onCustomEventNameChange(e, type, idx, "cost")} /></>
                            }
                          </>
                        )
                      }
                    </div>
                    <div className= {`${soaOncologyFlag? "td visits-td-oncology":"visits-td td f-1-small"}`} style={{ display: 'flex', justifyContent: 'left', alignItems: 'center' }}>{evt.totalVisit}</div>
                    </>)}
                    <div className="status-row e-row" style={{paddingLeft: 0}}>
                      <div className="colunm td" style={{ flex: 0, paddingLeft: 0 }}>
                        {viewOnly ? <PlusCircleOutlined /> : <Tooltip
                              title={
                                <ModalityList
                                  evt={evt}
                                  category={type}
                                  isRowBatch={true}
                                  rowModality={rowModality} />
                              }
                              color="#ffffff"
                              // trigger="click"
                              mouseEnterDelay={0.2}
                            >
                              <PlusCircleOutlined />
                            </Tooltip>
                          }
                      </div>
                    </div>
                  </div>
                  <div className="status-row e-row">
                    
                    {/* <div className="status-row e-row"> */}
                      {evt.condition.length > 0 &&
                        evt.condition.map((con, idx) => {
                          const targetItem = modalityOptions?.find(m => m.key == con.modality)
                          return viewOnly ? (
                            <div className="td" key={`${type.toLowerCase()}_event_${idx}`} style={{
                              // border: '1px solid #eeeeee',
                              // borderBottom:data.length > 1 ? '' : '1px solid #eeeeee',
                              backgroundColor:`${currentVisitIndex.includes(idx+1)? '#FFF' : '#DEDEDE'}`}}>
                              <span
                                className={`${viewOnly ? 'viewOnly' : ''} incon-wrapper`}
                                style={{backgroundColor:`${currentVisitIndex.includes(idx+1)? '#FFF' : '#DEDEDE'}`}}
                              >
                                {Boolean(con.modality) && con.modality !== "" ? <img src={targetItem.icon} style={{backgroundColor: targetItem.color}} /> : <PlusCircleOutlined />}
                              </span>
                            </div>
                          ) : (
                            <div className="td" key={`${type.toLowerCase()}_event_${idx}`} style={{
                              // border: '1px solid #eeeeee',
                              // borderBottom: data.length > 1 ? 'none' : '1px solid #eeeeee',
                               backgroundColor:`${currentVisitIndex.includes(idx+1)? '#FFF' : '#DEDEDE'}`}}>
                              <span className="incon-wrapper" style={{backgroundColor:`${currentVisitIndex.includes(idx+1)? '#FFF' : '#DEDEDE'}`}}>
                                <Tooltip
                                  title={<ModalityList evt={evt} idx={idx} value={con.modality} />}
                                  color="#ffffff"
                                  // trigger="click"
                                  mouseEnterDelay={0.2}
                                >
                 
                              {Boolean(con.modality) ? 
                                <img 
                                  src={targetItem.icon} 
                                  onClick={(e) => clickHandler(e, evt, idx)} 
                                  style={{
                                    backgroundColor: `${currentVisitIndex.includes(idx+1)? targetItem.color : 'rgb(203, 203, 203)'}`, 
                                    borderRadius: '50%',
                                  }}
                                 />
                              : 
                              <PlusCircleOutlined onClick={(e) => clickHandler(e, evt, idx)}/>
                            }
                            </Tooltip>
                              </span>
                            </div>
                          );
                        })} 
                  </div>
                  
                 <div style={{
                    width: "80px",
                    borderLeft:' 1px solid #eeeeee',
                    borderTop:' 1px solid #eeeeee',
                    borderBottom:' 1px solid #eeeeee',
                    textAlign: "center",
                    background: 'white',
                    position: 'sticky',
                    top: 0,
                    right: 0
                  }}> <a onClick={(e) => editSoaDetails(e, evt, idx)} className="edit-soa-details"> Details </a></div>
                 
                </div>
              );
            })}
        </div>
      </Panel>
    )
  }

  const panelMapping = [
    { key: "1", type: LABS, data: labs },
    { key: "2", type: PHYSICAL_EXAMINATION, data: examination },
    { key: "3", type: PROCEDURES, data: procedures },
    { key: "4", type: QUESTIONNAIRES, data: questionnaire },
    { key: "5", type: STUDY_PROCEDURES, data: studyProcedures },
  ];

  const showActivitySoaPage = () => {
    props.updateSoaActivities({
        soaAddedLabs: labs,
        soaAddedExamination: examination,
        soaAddedProcedures: procedures,
        soaAddedQuestionnaires: questionnaire,
        soaAddedStudyProcedures: studyProcedures,
        soaOrgLabs: orgLabs,
        soaOrgExamination: orgExamination,
        soaOrgProcedures: orgProcedures,
        soaOrgQuestionnaires: orgQuestionnaires,
        soaOrgStudyProcedures: orgStudyProcedures,
        soaVisits: visits.map((c,i) => c = i + 1),
        // soaWeeks: weeks, 
    }) 
    props.history.push({
      pathname: '/add-activity-soa',
      state: {
        addedLabs:labs,
        addedExamination: examination,
        addedProcedures: procedures,
        addedQuestionnaires: questionnaire, 
        addedStudyProcedures:studyProcedures,
        orgLabs,
        orgExamination,
        orgProcedures,
        orgQuestionnaires,
        orgStudyProcedures,
        filteredLabs: props?.newSoa?.soaFilteredLabs,
        filteredExamination: props?.newSoa?.soaFilteredExamination,
        filteredQuestionnaires: props?.newSoa?.soaFilteredQuestionnaires,
        filteredProcedures: props?.newSoa?.soaFilteredProcedures,
        filteredStudyProcedures: props?.newSoa?.soaFilteredStudyProcedures,
        trialEndpoints, 
        similarHistoricalTrials: props.similarHistoricalTrials,
        trial_id: props.trial_id,
        scenarioId: props.scenarioId, 
        scenarioType: props.scenarioType,
        modalityOptions: modalityOptions,
        evtNumbers: eventNumbers,
        // weeks: weeks,
        visits: visits,
        evtnotesList: props.visitsList,
        readOnly:(props.readOnlyUser&& props.readOnlyUser.toLowerCase() !== 'read' && !soeReadOnly ) && !disableSaveBtn()? false : true,
        soaPeriod_data: props?.newSoa?.soaPeriod_data,
        visitTypeLib,
        soaOncologyFlag,
       }
     })
  }

  elementM = panelMapping.map((panel) => {
    return generatePanel(panel);
  });

    const disableBtn = () => {
      if(elementM && elementM.length == 5 && filteredActivities.length > 0 && visits.length > 0) {
        return false;
      }
      return true;
    }

    const disableSaveBtn = () => {  
      const ischartsPresent = (elementM && elementM.length == 5 && filteredActivities?.length > 0 && visits?.length >0 && !props.saveButton )  
      if(ischartsPresent) {
        return false;
      }
      return true;
    }

    const handlePopoverVisibleChange = (index, visible) => { 
      const newStates = [...popoverStates];
      newStates[index] = visible;
      setPopoverStates(newStates);
    };

    const handleDragData = (activeIndex, overIndex, targetArr, operateArr) => {
      let startIndex = 0;  
      let targetIndex = 0; 
      let movePartLength = 0; 
      let insertIndex = 0;
      let elements = [];
      operateArr.slice(0, activeIndex).forEach(item => {
        // const lengthKey = titleToLengthKeyMap[item.visit_type];
        const length = item['no_of_visits'];
        startIndex = startIndex + length;
        return startIndex;
      })
      if (activeIndex < overIndex ) {
      // move to right       
      operateArr.slice(0, overIndex+1).forEach(item => {
        const length = item['no_of_visits'];
        targetIndex = targetIndex + length;
        return targetIndex;
      })
      // const _lengthKey = titleToLengthKeyMap[periodType[activeIndex].visit_type];
      movePartLength = periodType[activeIndex].no_of_visits;
      // Extract the elements to be moved  
      elements = targetArr.splice(startIndex, movePartLength);  
      // Find the index to insert the elements  
      insertIndex = targetIndex-elements.length;  
      } else if (activeIndex > overIndex ) {
      // move to left
      operateArr.slice(0, overIndex).forEach(item => {
        const length = item['no_of_visits'];
        targetIndex = targetIndex + length;
        return targetIndex;
      })
      movePartLength = periodType[activeIndex].no_of_visits;
      // Extract the elements to be moved  
      elements = targetArr.splice(startIndex, movePartLength);  
      // Find the index to insert the elements  
      insertIndex = targetIndex;  
      }
      // Insert the elements at the desired position  
      targetArr.splice(insertIndex, 0, ...elements);
      return targetArr
    }

    const onSOADragEnd = ({ active, over }) => {  
      if (active.id !== over?.id) {
        // 1 - change the order of category 'periodType'
        setPeriodType((prevState) => {
          const activeIndex = prevState.findIndex((i) => i.period_id === active?.id);
          const overIndex = prevState.findIndex((i) => i.period_id === over?.id);
  
        // 2 - visits should auto re-order in UI. 
        let newVisits = visits.slice(0)
        newVisits = handleDragData(activeIndex, overIndex, newVisits, prevState)
        setVisits(newVisits);        
       
        let newVisitsShowOnly = visitsShowOnly.slice(0);
        newVisitsShowOnly = handleDragData(activeIndex, overIndex, newVisitsShowOnly, prevState)
        setVisitsShowOnly(newVisitsShowOnly.map((visitValue, index) => {
          return {
            "unique_id": visitValue.unique_id,
            "order": index + 1,
            "value": visitValue.value,
          }
        }));
  
        // 3- change the order of weeks 
        let newWeeks = dayWeekList.map((week, idx)=>{
          return week[soaOncologyFlag?'days':'weeks']
        })
        newWeeks = handleDragData(activeIndex, overIndex, newWeeks, prevState)

        // 4- change the order of notes
        let notesArr = props?.newSoa?.soaVisitNotesList.map(note => note||'')

        notesArr = handleDragData(activeIndex, overIndex, notesArr, prevState)
        // setNotesList(notesArr)       
        props.visitNoteListHandler(notesArr);
  
        // 5- other data operation

        // update conditions
        let tmp_labs = reorderCondition(labs, activeIndex, overIndex, prevState) 
        let tmp_examination = reorderCondition(examination, activeIndex, overIndex, prevState) 
        let tmp_procedures = reorderCondition(procedures, activeIndex, overIndex, prevState) 
        let tmp_questionnaire = reorderCondition(questionnaire, activeIndex, overIndex, prevState) 
        let tmp_studyProcedures = reorderCondition(studyProcedures, activeIndex, overIndex, prevState)
        
        const tempVisitArray = newVisits.map((c,i) => c = i + 1)
        tmp_labs = renewCondition(tmp_labs,tempVisitArray, newWeeks)
        tmp_examination = renewCondition(tmp_examination,tempVisitArray, newWeeks)
        tmp_procedures = renewCondition(tmp_procedures,tempVisitArray, newWeeks)
        tmp_questionnaire = renewCondition(tmp_questionnaire,tempVisitArray, newWeeks)
        tmp_studyProcedures = renewCondition(tmp_studyProcedures,tempVisitArray, newWeeks)

        setLabs(  tmp_labs )
        setExamination(tmp_examination)
        setProcedures( tmp_procedures)
        setQuestionnaire( tmp_questionnaire)
        setStudyProcedures( tmp_studyProcedures )
      
        // return the updated 'periodType' 
        const newPeriodType = arrayMove(prevState, activeIndex, overIndex)
        // newPeriodType.map((c,i) => c.period_order_index = i + 1)
        newPeriodType.map((c, i) => {
          c.period_order_index = i + 1;
          c.period_id = i + 1; 
        });
        props.updateSoaActivities({
          soaPeriod_data: newPeriodType,
          soaVisits: newVisits.map((c,i) => c = i + 1),
        })
        return newPeriodType;
        });
      }
      setDragIndex({
        active: -1,
        over: -1,
        direction:'',
      });
    };
  
    const onSOADragOver = ({ active, over }) => {    
      const activeIndex = periodType.findIndex((i) => i.period_id === active.id);
      const overIndex = periodType.findIndex((i) => i.period_id === over?.id);
      setDragIndex({
        active: active.id,
        over: over?.id,
        direction: overIndex > activeIndex ? 'right' : 'left',
      });
    };

    function moveItemInArrayByIndices(targetArray, startIndex, endIndex) { 
      let array = JSON.parse(JSON.stringify([...targetArray]))
      let _startIndex  = startIndex
      let _endIndex = endIndex
      let moveIndex = -1
      let targetIndex = -1
      for (let index = 0; index < array.length; index++) {  
        const obj = array[index];  
        if (_startIndex + 1 <= obj.no_of_visits) {  
          moveIndex = index;  
          break;  
        } else {  
          _startIndex = _startIndex - obj.no_of_visits;  
        }  
      }   
      for (let index = 0; index < array.length; index++) {  
        const obj = array[index];
        if (_endIndex + 1 <= obj.no_of_visits) {  
          targetIndex = index;  
          break;  
        } else {  
          _endIndex = _endIndex - obj.no_of_visits;  
        }  
      }  
      return {moveIndex, targetIndex}
    }

    const onSOADragVisitEnd = ({ active, over }) => {
      if (active.id !== over?.id) {
        // 0 - change the order of visits  - 'visitsShowOnly'
        setVisitsShowOnly((prevState) => {
          const activeIndex = prevState.findIndex((i) => i.unique_id === active?.id);
          const overIndex = prevState.findIndex((i) => i.unique_id === over?.id);

        // 1 - update periodType 
        let newPeriodType = JSON.parse(JSON.stringify(periodType))
        let {moveIndex,targetIndex} = moveItemInArrayByIndices(newPeriodType, activeIndex, overIndex);  
        if (newPeriodType[moveIndex].no_of_visits === 1) {
          // No changes if the visit is the only one in the period
          return prevState
        } else {
          newPeriodType[moveIndex].no_of_visits = newPeriodType[moveIndex].no_of_visits - 1
          newPeriodType[targetIndex].no_of_visits = newPeriodType[targetIndex].no_of_visits + 1 
    
          // 2 - change the order of visits  - 'visits' 
          let newVisits = visits.slice(0)
          newVisits = arrayMove(newVisits, activeIndex, overIndex)
          setVisits(newVisits);                  
    
          // 3- change the order of weeks 
          let newWeeks = dayWeekList.map((week, idx)=>{
            return week[soaOncologyFlag?'days':'weeks']
          })
          newWeeks = arrayMove(newWeeks, activeIndex, overIndex)
          // setWeeks(newWeeks)
          // props.handleEventChange(newWeeks)          
  
          // 4- change the order of notes
          let notesArr = props?.newSoa?.soaVisitNotesList.map(note => note||'')
          notesArr = arrayMove(notesArr, activeIndex, overIndex)
          // setNotesList(notesArr)        
          props.visitNoteListHandler(notesArr);          
          // update periodType according to the new visits weeks and visit_notes
          let _newVisits = JSON.parse(JSON.stringify(newVisits))
          let _newWeeks = JSON.parse(JSON.stringify(newWeeks))
          let _newNotesArr = JSON.parse(JSON.stringify(notesArr))

          newPeriodType.forEach((period, index) => {
            const visits = _newVisits.splice(0, period.no_of_visits)
            const weeks = _newWeeks.splice(0, period.no_of_visits)            
            const visit_notes = _newNotesArr.splice(0, period.no_of_visits)
            period.visits = visits
            if(soaOncologyFlag){
              period.days = weeks
            } else {
              period.weeks = weeks
            }
            period.visit_notes = visit_notes
          }
          )          
          setPeriodType(newPeriodType)
          props.updateSoaActivities({
            soaPeriod_data:  newPeriodType,
            soaVisits: newVisits.map((c,i) => c = i + 1),
          }) 
    
          // 5- update conditions
          let tmp_labs = reorderConditionByVisit(labs, activeIndex, overIndex, prevState) 
          let tmp_examination = reorderConditionByVisit(examination, activeIndex, overIndex, prevState) 
          let tmp_procedures = reorderConditionByVisit(procedures, activeIndex, overIndex, prevState) 
          let tmp_questionnaire = reorderConditionByVisit(questionnaire, activeIndex, overIndex, prevState) 
          let tmp_studyProcedures = reorderConditionByVisit(studyProcedures, activeIndex, overIndex, prevState) 

          const tempVisitArray = newVisits.map((c,i) => c = i + 1)
          tmp_labs = renewCondition(tmp_labs,tempVisitArray, newWeeks)
          tmp_examination = renewCondition(tmp_examination,tempVisitArray, newWeeks)
          tmp_procedures = renewCondition(tmp_procedures,tempVisitArray, newWeeks)
          tmp_questionnaire = renewCondition(tmp_questionnaire,tempVisitArray, newWeeks)
          tmp_studyProcedures = renewCondition(tmp_studyProcedures,tempVisitArray, newWeeks)
          
          setLabs(tmp_labs)
          setExamination(tmp_examination)
          setProcedures(tmp_procedures)
          setQuestionnaire(tmp_questionnaire)
          setStudyProcedures(tmp_studyProcedures )
          // props.updateSoaActivities({soaAddedLabs : tmp_labs}) 
          // props.updateSoaActivities({soaAddedExamination : tmp_examination}) 
          // props.updateSoaActivities({soaAddedProcedures : tmp_procedures}) 
          // props.updateSoaActivities({soaAddedQuestionnaires : tmp_questionnaire}) 
          // props.updateSoaActivities({soaAddedStudyProcedures : tmp_studyProcedures})
    
          // return the updated 'visitsShowOnly' 
          let newVisitsShowOnly = arrayMove(prevState, activeIndex, overIndex).map((visitValue, index) => {
            return {
              "unique_id": visitValue.unique_id,
              "order": index + 1,
              "value": visitValue.value,
            }
          })                    
          return newVisitsShowOnly;
        }      
        });
      }
      setDragVisitIndex({
        active: -1,
        over: -1,
        direction:'',
      });
    };
  
    const onSOADragVisitOver = ({ active, over }) => {    
      const activeIndex = visitsShowOnly.findIndex((i) => i.unique_id === active.id);
      const overIndex = visitsShowOnly.findIndex((i) => i.unique_id === over?.id);
      setDragVisitIndex({
        active: active.id,
        over: over?.id,
        direction: overIndex > activeIndex ? 'right' : 'left',
      });
    };

  return (
    <div className="event-list-container" style={{position: "relative"}}>
      <div className="container-top">
        <div className="scenarios-heading-left"> 
            <span> Schedule of activities </span>
        </div>
        <div>
        </div>
        <div className="scenarios-heading-right">
            <div className='btn-scenarios-container-header '>
            {!viewOnly&& ( <>
            <Button className="soa-btn" disabled={!disableBtn() ? false : true} onClick={showConfigureModal} style={{zIndex: 1}}> Configure schedule </Button>
            <Button className="soa-btn" disabled={!disableBtn() ? false : true} 
            onClick={showActivitySoaPage} style={{zIndex: 1}}> <PlusCircleOutlined className="soa-activity-icon" /> Add activity </Button>
            <Button 
             disabled={(props.readOnlyUser&& props.readOnlyUser.toLowerCase() !== 'read' && !soeReadOnly )  &&  !disableSaveBtn() ? false : true}
             onClick={onSave}
             type="primary" className="save_soa_btn" style={{zIndex: 1}}> Save </Button></>)}  
            </div> 
        </div>
      </div>
      <div className="event-dashboard" style={{ minHeight: '500px', maxHeight: '700px', overflowY:'scroll', overflowX: "scroll" }} >
        <div className="dashboard-head" style={{top: "0px", position: "sticky", zIndex: 100, backgroundColor: "#FFF" }}>
          <div className="event-list-head" ref={eventListHead}>
          <div className="head-row" style={{position:"relative"}}>
          <div style={{ position: "sticky", 
          width: !showMetrics? "450px" :"690px", 
          left: "0", top: "0", backgroundColor: "#FFF", zIndex: 100, borderRight: "1px solid #eeeeee"}}> 
                <div className="visit-row e-row number" 
                style={{ position: "relative", 
                float: 'right',
                borderRight: 'none',
                borderTop: 'none',
                width: "50px", height: "33px" }}>
                  <div className="colunm td"></div>
                </div>
                <div style={{
                  // width: '80px',
                  // textAlign: 'center',
                  // borderLeft:' 1px solid #eeeeee',
                  // borderTop:' 1px solid #eeeeee',
                  background: 'white',
                  position: 'sticky',
                  zIndex: 100,
                  top: 0,
                  right: 0,
                  height: '33px',
                  // float: 'right',
                  lineHeight: '33px',
                  fontSize: '13px',
                  display: 'flex',
                  justifyContent: !showMetrics? 'left': 'right',

                }}>
                  {visitTypes?.map((o, index) => {
                    return (
                      <div className="legend-wrapper" key={o?.visit_type_id}>
                      <div className="legend-box" style={{backgroundColor: `${colorList[colorList.findIndex((i) => i.visit_type_id === o.visit_type_id)]?.color}`}}></div>
                      <div className="legend-title">{toSentenceCase(o?.visit_type)}</div>
                    </div>
                    );
                  })}
                </div>
              </div>
              <div className="visit-row e-row number" style={{ height: "33px" }}>
                <DndContext
                  sensors={sensors}
                  modifiers={[restrictToHorizontalAxis]}
                  onDragEnd={onSOADragEnd}
                  onDragOver={onSOADragOver}
                  collisionDetection={closestCenter}
                >
                  <SortableContext items={periodType.map((i) => i?.period_id?.toString())} strategy={horizontalListSortingStrategy}>
                    <DragIndexContext.Provider value={dragIndex}> 
                      {periodType.map(v =>      
                        <DraggableItem 
                         key={v.period_id}
                         item={v}
                      />)}
                    </DragIndexContext.Provider>
                  </SortableContext>
                  <DragOverlay>
                    <div
                      style={{
                        fontSize: '10px', 
                      }}
                    >
                    {periodType[periodType.findIndex((i) => i.period_id === dragIndex.active)]?.period_name}
                    </div>
                  </DragOverlay>
                </DndContext>
              </div>
              <div style={{
                  width: '80px',
                  textAlign: 'center',
                  borderLeft:' 1px solid #eeeeee',
                  borderTop:' 1px solid #eeeeee',
                  background: 'white',
                  position: 'sticky',
                  zIndex: 100,
                  top: 0,
                  right: 0
                }}></div>
            </div>
            <div className="head-row" style={{ position: "relative" }}>
              <div style={{ position: "sticky",
                width: !showMetrics? "450px":"690px",
                left: "0", 
                top: "0", 
                backgroundColor: "#FFF",
                zIndex: 100, 
                borderRight: "1px solid #eeeeee", 
                borderTop: "1px solid #eeeeee"}}>
                {/* <div className="colunm-row e-row" style={{ position: "relative", left: "0", top: "0", width: "634px", height: "33px" }}></div> */}
                <div className="visit-row e-row number" style={{ position: "relative", paddingLeft: !showMetrics?"398px" :"638px", width: "50px", height: "33px" }}>
                  <div className="colunm td" >Visits</div>
                </div>
              </div>
              <div className="visit-row e-row number" style={{ height: "33px",  borderBottom: "none" }}>
                <DndContext
                  sensors={sensors}
                  modifiers={[restrictToHorizontalAxis]}
                  onDragEnd={onSOADragVisitEnd}
                  onDragOver={onSOADragVisitOver}
                  collisionDetection={closestCenter}
                >
                  <SortableContext items={visitsShowOnly.map((i) => i?.unique_id?.toString())} strategy={horizontalListSortingStrategy}>
                    <DragIndexContext.Provider value={dragVisitIndex}> 
                  {
                    visitsShowOnly.map((v,i) => 
                      <DraggableVisit
                      key={v.unique_id}
                      item={v}
                      index={i}
                    />)} 
                </DragIndexContext.Provider>
                </SortableContext>
                <DragOverlay>
                  <div
                    style={{
                      fontSize: '14px', 
                      // backgroundColor: "#FFF",
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'center',
                      paddingTop: 0,
                      // borderLeft: '1px solid #eeeeee',
                    }}
                  >
                    <MenuOutlined style={{fontSize: '8px',marginTop: '0px', marginLeft: '0px', color: 'black',}}/>
                    <span style={{fontSize: '14px',marginTop: '0px',textAlign: 'center'}}>{visitsShowOnly[visitsShowOnly.findIndex((i) => i.unique_id === dragVisitIndex.active)]?.value}</span>
                  </div>
                </DragOverlay>
                </DndContext>
              </div>
              <div style={{
                  width: '80px',
                  textAlign: 'center',
                  borderLeft:' 1px solid #eeeeee',
                  borderTop:' 1px solid #eeeeee',
                  borderBottom:' 1px solid #eeeeee',
                  background: 'white',
                  position: 'sticky',
                  zIndex: 100,
                  top: 0,
                  right: 0
                }}></div>
            </div>
            <div className="head-row" style={{ position: "relative" }}>
              <div className="colunm-row week-row e-row" style={{ position: "sticky", left: "0", top: "0", width: !showMetrics? "450px":"690px", height: "132px", backgroundColor: "#FFF", zIndex: 100 }}>
                <div className="f-2-new" style={{ width: "330px" , height: "100%", }}>My activities</div>  
                  <div className="weeks-container" style={{    display: 'flex', width: showMetrics ? "410px" : '100px', height:' 100%',  flexDirection: 'column'}}> 
                    <div className="visit-row e-row number" style={{height: '55px', position: "relative", alignItems: 'center', backgroundColor: '#CBCBCB'}}>
                     {showMetrics ?  (<MinusSquareOutlined style={{padding: '0 10px'}} onClick={metricToggle}/>) : ( <PlusSquareOutlined style={{padding: '0 10px'}} onClick={metricToggle} /> )}
                     {showMetrics ? ' Hide metrics' : 'Show metrics'   }
                    </div>
                <div style={{height: '70%',  position: 'relative', display:' flex' }}> 
                {showMetrics && (
                  <>
                  <div className="f-3" style={{ width: soaOncologyFlag ? "150px" : "78.4px", paddingLeft: "10px" }}>Historical activity frequency</div>
                  {!soaOncologyFlag && (
                    <>
                      <div className="f-3" style={{ width: "78.4px", paddingLeft: "10px" }}>Historical visit frequency</div>
                      <div className="f-2-small" style={{ width: "85.4px", paddingLeft: "10px" }}>Scenario visit frequency</div>
                    </>
                  )}
          
                 <div className="f-1-small sortable-item" style={{ width: soaOncologyFlag ? "130px" : "110.8px", }}>Cost per patient
                 <span className="sort-icon-wrapper">
                 <img src={ascendIcon} onClick={() => setSort("ascend")} style={{ width: '16px', height: '16px', margin: '0 8px',color: sort == "ascend" ? "#ca4a04" : "rgb(85,85,85)"}} alt="Ascend" />
                 <img src={descendIcon} onClick={() => setSort("descend")} style={{ width: '16px', height: '16px', margin: '0 8px',color: sort == "descend" ? "#ca4a04" : "rgb(85,85,85)" }} alt="Descend" />
                    </span>
                  </div>
                  <div className="f-2-small" style={{ width: soaOncologyFlag ? "26.4px" : "56.4px", }}>Total visits</div>
                  </>
                )}             
                 </div>
                </div> 
                 
               
               
                <div className="head-bottom-container" style={{ height: "132px" }}>
                  <div className="e-row number" style={{ border: "0px", borderBottom: !showMetrics ? "1px solid #eeeeee" : "none" }}>
                    <div className="colunm td row-title" style={{ flex: 0 }}>{soaOncologyFlag ? 'Days' : 'Weeks'}</div>
                  </div>
                </div>
              </div>
              <div className="head-bottom-container" style={{ height: "99px" }}>
                <div className="e-row number">
                  {/* <div className="colunm td row-title" style={{ flex: 0 }}>Weeks</div> */}
                  <div className="week-row-wrapper" style={{ flex: 1 }}>
                    <div className="weeks-container">
                      {
                        dayWeekList.map((week, idx) => {
                          return viewOnly ?
                            <span className="td num-cell" style={{backgroundColor:`${currentVisitIndex.includes(idx+1)? '#FFF' : '#DEDEDE'}`}} key={`week_span_${idx}`}>{dayWeekList[idx][soaOncologyFlag ? 'days' : 'weeks']}</span> :
                            <Input className="td cell-input" style={{fontSize: "14px",backgroundColor:`${currentVisitIndex.includes(idx+1)? '#FFF' : '#DEDEDE'}`}} key={`week_${idx}`} value={dayWeekList[idx][soaOncologyFlag ? 'days' : 'weeks']} onChange={(e) => weekDayChangeHandler(e, idx)} />
                        })
                      }
                    </div>
                    <div className="visit-row e-row number" style={{ height: "55px", position: "relative" }}>
                        {
                          visits.length > 0 && visits.map((v, i)=> {
                            const notesValue = getNotesValue(i);
                            const popoverContent = popOverContent(i,viewOnly);
                            return popoverContent ? (
                              <div className="td num-cell" key={i} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center',backgroundColor:`${currentVisitIndex.includes(i+1)? '#FFF' : '#DEDEDE'}` }}>
                                {!notesValue ? (
                            <Popover style={{ backgroundColor: '#282f34'}} content={() => popoverContent} placement="bottom" visible={popoverStates[i] || false} onVisibleChange={(visible) => handlePopoverVisibleChange(i, visible)} overlayClassName="visit-tooltip">
                                {/* <FileAddFilled /> */}
                                <img src={NoteAddIcon} style={{height: "25px", width: "25px"}} />
                            </Popover>
                    ) : (
                            <Popover style={{ backgroundColor: '#282f34'}} content={() => popoverContent} placement="bottom" overlayClassName="visit-tooltip" trigger="click" visible={popoverStates[i] || false} onVisibleChange={(visible) => handlePopoverVisibleChange(i, visible)}>
                                <Text 
                                style={{width: "90%"}}
                                ellipsis={{tooltip:notesValue}}
                                >
                                    {notesValue}
                                </Text>
                            </Popover>
                    )}
                      </div>
                            ):(
                              <div className="td num-cell" key={v}>
                                <Text 
                                  style={{width: "90%",backgroundColor:`${currentVisitIndex.includes(i+1)? '#FFF' : '#DEDEDE'}`}}
                                  ellipsis={{tooltip:notesValue}}
                                  >
                                    {notesValue}
                                  </Text>
                              </div>
                            )
                          })
                        }
                    </div>
                    <div className="column-action-container">
                      {
                        visits.map((visit, idx) => {
                          return viewOnly ? (
                            <div className="td num-cell" key={idx}>
                              <PlusCircleOutlined />
                            </div>
                          ) : (
                            <div className="td num-cell" key={idx}>
                              <Tooltip
                                title={
                                  <ModalityList
                                    idx={idx}
                                    isColumnBatch={true}
                                    columnModality={columnModality}
                                    insertColumn={insertColumn}
                                    deleteColumn={deleteColumn}
                                  />
                                }
                                color="#ffffff"
                                // trigger="click"
                                mouseEnterDelay={0.2}
                              >
                                <PlusCircleOutlined />
                              </Tooltip>
                            </div>
                          )
                        })
                      }
                    </div>
                    <div style={{ width: '80px', textAlign: 'center',  borderLeft:' 1px solid #eeeeee',borderTop:' 1px solid #eeeeee',borderBottom:' 1px solid #eeeeee', }}></div>
                  </div>
                </div>
              </div>
              <div style={{
                width: "80px",
                textAlign: "center",
                borderLeft:' 1px solid #eeeeee',
                borderTop:' 1px solid #eeeeee',
                borderBottom:' 1px solid #eeeeee',
                background: 'white',
                position: 'sticky',
                top: 0,
                right: 0
              }}></div>
            </div>
          </div>
        </div>
        <Spin spinning={elementM && elementM.length == 5 && visits?.length > 0 ? false : true} indicator={<LoadingOutlined style={{ color: "#ca4a04",fontSize: 24 }}/>}>
        <Collapse className="clearfix" style={{ width: collapseWidth ?? `${collapseWidth}px` }}  activeKey={expandKeys} onChange={callback}>
          {
            elementM
          }
        </Collapse>
        </Spin>
      </div>

      <SoaDetailsModal 
        selectedEditActivity={selectedEditActivity}
        endpointsSelector={endpointsSelector}
        handleCancelEditActivity={handleCancelEditActivity}
        editActivityModal={editActivityModal}
        handleOkEditActivity={handleOkEditActivity}
      />        
    </div>
  );
};

const mapDispatchToProps = (dispatch) => ({
  createTrial: (val) => dispatch(createActions.createTrial(val)),
  createSoa: (val) => dispatch(createActions.createSoa(val)), 
  updateSoaActivities: (val) => dispatch(createActions.updateSoaActivities(val))
});

const mapStateToProps = (state) => ({
newTrial: state.trialReducer,
newSoa: state.soaReducer, 
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(NewEventList));